// import store from "../Store/store";
// const response = store.getState()?.auth

import moment from 'moment-timezone'

export const roleType = {
    clinic: 'clinic',
    patient: 'patient',
    provider: 'provider',
    user: 'user',
    appointment: 'appointment',
    superbill: 'superbill',
    claim: 'claim',
    payment: 'payment',
    checkout: 'checkout',
    billingteam: 'billingteam',
    Cred_doc: 'Cred_doc',
    Cred_Serv_Order: 'Cred_Serv_Order',
    Cred_Assoc: 'Cred_Assoc',
}

export const Network_error = 'Network error'
export const modalEnum = { open: false, data: null }
export const tableRowStyle = {
    '& .MuiTableCell-root': {
        padding: '8px 8px',
        fontSize: '12px',
        lineHeight: '1',
    },
}

export const getTableRowStyle = (padding = '8px 8px', fontSize = '12px', lineHeight = '1') => ({
    '& .MuiTableCell-root': {
        padding,
        fontSize,
        lineHeight,
    },
})

export const caseTypeSuperBillFilter = [
    { name: 'All', value: 'All' },
    { name: 'Self-Pay', value: 'SELF_PAY' },
    { name: 'INSURANCE', value: 'INSURANCE' },
    { name: 'No-Show', value: 'NO_SHOW' },
]

export const planTypeSuperBillFilter = [
    { name: 'Primary', value: 'Primary' },
    { name: 'Secondary', value: 'Secondary' },
    { name: 'Tertiary', value: 'Tertiary' },
]

export const insurancePlanSuperBillFilter = [
    { name: 'HMO', value: 'HMO' },
    { name: 'PPO', value: 'PPO' },
    { name: 'EAP', value: 'EAP' },
    { name: 'EPO', value: 'EPO' },
    { name: 'Unknown', value: 'Unknown' },
]

export const planCategorySuperBillFilter = [
    { name: 'Medicaid', value: 'Medicaid' },
    { name: 'Medicare', value: 'Medicare' },
    { name: 'Other', value: 'Other' },
]

export const paymentModeType = [
    // { title: "Cash", id: "CASH" },
    { title: 'EFT', id: 'EFT' },
    { title: 'Check', id: 'CHEQUE' },
    { title: 'ERA', id: 'ERA' },
    // { title: "Other", id: "OTHER" },
]
// Rple And permissions
// Auth Guard
// listing but add button

export const Permissionsobj = {
    CLINIC: {
        label: 'Clinic',
        read: true,
        write: true,
    },
    PATIENT: {
        label: 'Patient',
        read: true,
        write: true,
        parent: 'CLINIC',
    },
    PROVIDER: {
        label: 'Provider',
        read: true,
        write: true,
        parent: 'CLINIC',
    },
    APPOINTMENT: {
        label: 'Appointment',
        read: true,
        write: true,
        parent: 'CLINIC',
    },
    CHECKOUT: {
        label: 'Check Out',
        read: true,
        write: true,
        parent: 'CLINIC',
    },
    BILLINGTEAM: {
        label: 'Billing Team',
        read: true,
        write: true,
    },
    SUPERBILL: {
        label: 'Super Bill',
        read: true,
        write: true,
    },
    CLAIMS: {
        label: 'Claims',
        read: true,
        write: true,
    },
    REPORTS: {
        label: 'Reports',
        read: true,
        write: true,
    },
    PAYMENTS: {
        label: 'Payments',
        read: true,
        write: true,
    },
    ANNOUNCEMENTS: {
        label: 'Announcements',
        read: true,
        write: true,
    },
    'ROLES & PERMISSIONS': {
        label: 'Roles and permissions',
        read: true,
        write: true,
    },
    SETTINGS: {
        label: 'Settings',
        read: true,
        write: true,
    },
    CPT: {
        label: 'CPT',
        read: true,
        write: true,
    },
    ICD: {
        label: 'ICD',
        read: true,
        write: true,
    },
    CREDENTIALING: {
        label: 'Credentialing',
        read: true,
        write: true,
    },
    FOLLOWUP: {
        label: 'Follow Up',
        read: true,
        write: true,
    },
    PROBLEMLOG: {
        label: 'Problem Log',
        read: true,
        write: true,
    },
}

export const Permissions = [
    {
        title: 'clinic',
        read: true,
        write: true,
    },
    {
        title: 'patient',
        read: false,
        write: false,
    },
    {
        title: 'provider',
        read: false,
        write: false,
    },
    {
        title: 'appointment',
        read: false,
        write: false,
    },
    {
        title: 'checkout',
        read: false,
        write: false,
    },
    {
        title: 'billing_team',
        read: false,
        write: false,
    },
    {
        title: 'billing_team_members',
        read: false,
        write: false,
    },
]

export const paymentRadioEnum = {
    transactionTypeModel: [
        { name: 'Payment', value: 'INSURANCE_PAYMENT' },
        { name: 'Refund', value: 'REFUND' },
    ],
    paymentFromModel: [
        { name: 'Insurance', value: 'INSURANCE' },
        { name: 'Patient', value: 'PATIENT' },
    ],
    paymentModeModel: [
        { name: 'Check', value: 'CHEQUE' },
        { name: 'Credit Card', value: 'CARD' },
        { name: 'EFT', value: 'EFT' },
    ],
    creditCardModeModel: [
        { name: 'Payment', value: 'PAYMENT' },
        { name: 'Refund', value: 'REFUND' },
    ],
}

export const clinicType = {
    individual: 'individual',
    group: 'group',
}

// get current Time zone
export const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

// visit Type

export const visitType = [{ type: 'Physical' }, { type: 'Tele-Call' }]

// visit Type

export const visitTypeList = [
    { name: 'Physical', id: 'Physical' },
    { name: 'Tele-Call', id: 'Tele-Call' },
]

export const claimTypeList = [
    { id: 'SELF_PAY', name: 'Self-Pay' },
    { id: 'INSURANCE', name: 'Insurance' },
    { id: 'NO_SHOW', name: 'No-show' },
    { id: 'FOR_PAYMENT_POST_ENTRY', name: 'For Payment Post Entry' },
    { id: 'FOR_ALREADY_SUBMIITED_CLAIM', name: 'For Already Submitted Claim' },
]

export const visitTypeNew = [
    { name: true, id: 'All' },
    { name: 'SELF_PAY', id: 'Self-Pay' },
    { name: 'INSURANCE', id: 'Insurance' },
    { name: ' NO_SHOW', id: 'No-show' },
]

export const Status = ['Accepted', 'Cancelled', 'Checkout']
// export const Status = ["Accepted", "Pending", "Rescheduled", "Unavailability", "Cancelled", "Declined", "Checkout"]

//  colors list
export const colorsList = [
    { code: '#214559' },
    { code: '#00626f' },
    { code: '#391285' },
    { code: '#0000aa' },
    { code: '#11887b' },
    { code: '#696006' },
    { code: '#004953' },
    { code: '#d1001c' },
    { code: '#900020' },
    { code: '#d5b60a' },
    { code: '#4a0100' },
    { code: '#af2f0d' },
    { code: '#9c004a' },
    { code: '#cb416b' },
    { code: '#d90166' },
    { code: '#490648' },
    { code: '#80444c' },
    { code: '#673a3f' },
    { code: '#605467' },
    { code: '#754600' },
    { code: '#4f1507' },
    { code: '#341c02' },
    { code: '#937a62' },
    { code: '#5c5337' },
    { code: '#415764' },
    { code: '#333333' },
    { code: '#363737' },
    { code: '#646356' },
    { code: '#6f828a' },
    { code: '#171717' },
    { code: '#5729ce' },
    { code: '#5a4fcf' },
    { code: '#e17701' },
    { code: '#e08119' },
    { code: '#e1ad01' },
    { code: '#e27a53' },
    { code: '#fc642d' },
    { code: '#ff7f00' },
    { code: '#9878f8' },
    { code: '#6c3461' },
    { code: '#4b0082' },
    { code: '#871f78' },
    { code: '#871f78' },
    { code: '#412a7a' },
    { code: '#ebe5d0' },
    { code: '#eeebe3' },
    { code: '#014421' },
    { code: '#048243' },
    { code: '#004b49' },
    { code: '#446d46' },
    { code: '#a3fa4b' },
    { code: '#66ffc9' },
    { code: '#48eab1' },
    { code: '#fa5b09' },
]

// place_of_service Arrr
export const place_of_service = [
    { code: '01', name: `Pharmacy` },
    { code: '02', name: `Telehealth provided other than in Patient's Home` },
    { code: '03', name: `School` },
    { code: '04', name: `Homeless Shelter` },
    { code: '05', name: `Indian Health Service Free - Standing Facility` },
    { code: '06', name: `Indian Health Service Provider - Based Facility` },
    { code: '07', name: `Tribal 638 Free-standing Facility` },
    { code: '08', name: `Tribal 638 Provider based Facility` },
    { code: '09', name: `Prison - Correctional Facility` },
    { code: '10', name: `Telehealth provided in Patient's Home` },
    { code: '11', name: `Office` },
    { code: '12', name: `Home` },
    { code: '13', name: `Assisted Living Facility` },
    { code: '14', name: `Group Home` },
    { code: '15', name: `Mobile Unit` },
    { code: '16', name: `Temporary Lodging` },
    { code: '17', name: `Walk in Retail Health Clinic` },
    { code: '18', name: `Place of employment - worksite` },
    { code: '19', name: `Off Campus - Outpatient Hospital` },
    { code: '20', name: `Urgent Care Facility` },
    { code: '21', name: `Inpatient Hospital` },
    { code: '22', name: `On Campus - Outpatient Hospital` },
    { code: '23', name: `emergency Room Hospital` },
    { code: '24', name: `Ambulatory Surgical Center` },
    { code: '25', name: `Birthing center` },
    { code: '26', name: `Military Treatment Facility` },
    { code: '31', name: `Skilled Nursing Facility` },
    { code: '32', name: `Nursing Facility` },
    { code: '33', name: `Custodial Care Facility` },
    { code: '34', name: `Hospice` },
    { code: '41', name: `Ambulance Land` },
    { code: '42', name: `Ambulance Air or Water` },
    { code: '49', name: `Independent Clinic` },
    { code: '50', name: `Federally Qualified Health Center` },
    { code: '51', name: `Inpatient Psychiatric Facility` },
    { code: '52', name: `Psychiatric Facility Partial Hospitalization` },
    { code: '53', name: `Community mental health center` },
    { code: '54', name: `Intermediate Care Facility/Mentally Retarded` },
    { code: '55', name: `Residential Substance Abuse Treatment Facility` },
    { code: '56', name: `Psychiatric Residential Treatment Center` },
    { code: '57', name: `Non residential Substance Abuse Treatment Facility` },
    { code: '58', name: `Non residential Opioid Treatment Facility` },
    { code: '60', name: `Mass Immunization center` },
    { code: '61', name: `Comprehensive Inpatient Rehabilitation Center` },
    { code: '62', name: `Comprehensive Outpatient Rehabilitation Center` },
    { code: '65', name: `End Stage Renal Disease Treatment Facility` },
    { code: '71', name: `State or Local Public Health Clinic` },
    { code: '72', name: `Rural Health Clinic` },
    { code: '81', name: `Independent Laboratory` },
    { code: '99', name: `Other Place of Service` },
]

export const type_of_service = [
    { name: 'MEDICAL CARE', key: 'MEDICALCARE' },
    { name: 'SURGERY', key: 'SURGERY' },
    { name: 'CONSULTATION', key: 'CONSULTATION' },
    { name: 'DIAGNOSTIC X-RAY', key: 'DIAGNOSTICXRAY' },
    { name: 'DIAGNOSTIC LABORATORY', key: 'DIAGNOSTICLABORATORY' },
    { name: 'RADIATION THERAPY', key: 'RADIATIONTHERAPY' },
    { name: 'ANESTHESIA', key: 'ANESTHESIA' },
    { name: 'SURGICAL ASSISTANCE', key: 'SURGICALASSISTANCE' },
    { name: 'OTHER MEDICAL', key: 'OTHERMEDICAL' },
    { name: 'BLOOD CHARGES', key: 'BLOODCHARGES' },
    { name: 'USED DME', key: 'USEDDME' },
    { name: 'DME PURCHASE', key: 'DMEPURCHASE' },
    { name: 'ASC FACILITY', key: 'ASCFACILITY' },
    { name: 'RENAL SUPPLIES IN THE HOME', key: 'RENALSUPPLIESINTHEHOME' },
    { name: 'ALTERNATE METHOD DIALYSIS', key: 'ALTERNATEMETHODDIALYSIS' },
    { name: 'CRD EQUIPMENT', key: 'CRDEQUIPMENT' },
    { name: 'PRE-ADMISSION TESTING', key: 'PREADMISSIONTESTING' },
    { name: 'DME RENTAL', key: 'DMERENTAL' },
    { name: 'PNEUMONIA VACCINE', key: 'PNEUMONIAVACCINE' },
    { name: 'SECOND SURGICAL OPINION', key: 'SECONDSURGICALOPINION' },
    { name: 'THIRD SURGICAL OPINION', key: 'THIRDSURGICALOPINION' },
]

//  clinic List Head cells
export const clinicHeadCells = [
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: '#',
        isShorted: false,
    },
    {
        id: 'clinic_name',
        numeric: true,
        disablePadding: true,
        label: 'Name',
        isShorted: true,
    },
    {
        id: 'userEmail',
        numeric: true,
        disablePadding: false,
        label: 'E-mail Address',
        isShorted: true,
    },
    {
        id: 'clinic_type',
        numeric: true,
        disablePadding: false,
        label: 'Type',
        isShorted: false,
    },

    {
        id: 'Status',
        numeric: true,
        disablePadding: false,
        label: 'Status',
        isShorted: false,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]

// Skills  list
export const SkillsHeadCells = [
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: '#',
        isShorted: false,
    },
    {
        id: 'name',
        numeric: true,
        disablePadding: true,
        label: 'Name',
        isShorted: true,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]

// Clinic Group list
export const clinicGroupHeadCells = [
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: '#',
        isShorted: false,
    },
    {
        id: 'clinic_name',
        numeric: true,
        disablePadding: true,
        label: 'Name',
        isShorted: true,
    },
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: 'Clinics',
        isShorted: false,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]

// Assign to billing team list
export const AssignBillingTeamHeadCells = [
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: '#',
        isShorted: false,
    },
    {
        id: 'Name',
        numeric: false,
        disablePadding: false,
        label: 'Name',
        isShorted: true,
    },
    {
        id: '',
        numeric: false,
        disablePadding: false,
        label: 'Clinic Assigned',
        isShorted: true,
    },
    {
        id: '',
        numeric: false,
        disablePadding: false,
        label: 'Team Members',
        isShorted: true,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]

// Payment List
export const PaymetHeadCells = [
    {
        id: 'Claim #',
        numeric: true,
        disablePadding: true,
        label: 'Ins.Payer/Plan/Company',
        isShorted: true,
    },
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: 'Payment.Type',
        isShorted: false,
    },
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: 'Payment.Mode',
        isShorted: false,
    },
    {
        id: 'Reference',
        numeric: true,
        disablePadding: false,
        label: 'Reference',
        isShorted: false,
    },
    {
        id: 'Reference Date',
        numeric: true,
        disablePadding: false,
        label: `Reference ( Date )`,
        isShorted: false,
    },
    {
        id: 'Received Date',
        numeric: true,
        disablePadding: false,
        label: 'Received(Date)',
        isShorted: false,
    },
    {
        id: '# Claims',
        numeric: true,
        disablePadding: false,
        label: '#Claims',
        isShorted: false,
    },
    {
        id: 'Identified Claims',
        numeric: true,
        disablePadding: false,
        label: 'Identified.Claims',
        isShorted: false,
    },
    {
        id: 'Unidentified Claims',
        numeric: true,
        disablePadding: false,
        label: 'Unidentifie.Claims',
        isShorted: false,
    },
    {
        id: 'Excluded Claims',
        numeric: true,
        disablePadding: false,
        label: 'Excluded.Claims',
        isShorted: false,
    },
    {
        id: 'Charge Amt. ($)',
        numeric: true,
        disablePadding: false,
        label: 'Charge/Amt($)',
        isShorted: false,
    },
    {
        id: 'Payment Amt. ($)',
        numeric: true,
        disablePadding: false,
        label: `Payment/Amt($)`,
        isShorted: false,
    },
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: 'Prov.Paid/Amt($)',
        isShorted: false,
    },
    {
        id: 'Prov - Adj. Amt($)',
        numeric: true,
        disablePadding: false,
        label: 'Prov.Adj.Amt($)',
        isShorted: false,
    },
    {
        id: 'Excluded Amt. ($)',
        numeric: true,
        disablePadding: false,
        label: 'Excluded/Amt($)',
        isShorted: false,
    },
    {
        id: 'Applied Amt. ($)',
        numeric: true,
        disablePadding: false,
        label: 'Applied/Amt($)',
        isShorted: false,
    },
    {
        id: 'Unapplied Amt. ($)',
        numeric: true,
        disablePadding: false,
        label: 'Unapplied/Amt($)',
        isShorted: false,
    },
    {
        id: 'User',
        numeric: true,
        disablePadding: false,
        label: 'User',
        isShorted: false,
    },
    {
        id: 'Action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]

// Reports List

export const TotalARHeadCell = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: true,
    },
    {
        id: 'First Name',
        numeric: true,
        disablePadding: false,
        label: 'First Name',
        isShorted: true,
    },
    {
        id: 'Last Name',
        numeric: true,
        disablePadding: false,
        label: 'Last Name',
        isShorted: true,
    },
    {
        id: 'Patient ID',
        numeric: true,
        disablePadding: false,
        label: 'Patient ID',
        isShorted: true,
    },
    {
        id: 'DOS',
        numeric: true,
        disablePadding: false,
        label: 'DOS',
        isShorted: true,
    },
    {
        id: 'Provider',
        numeric: true,
        disablePadding: false,
        label: 'Provider',
        isShorted: true,
    },
    {
        id: 'Primary Insurance',
        numeric: true,
        disablePadding: false,
        label: 'Primary Insurance',
        isShorted: true,
    },
    {
        id: 'Procedure',
        numeric: true,
        disablePadding: false,
        label: 'Procedure',
        isShorted: false,
    },
    {
        id: 'Date of Submission',
        numeric: true,
        disablePadding: false,
        label: 'Date of Submission',
        isShorted: true,
    },
    {
        id: 'Charge Amt.',
        numeric: true,
        disablePadding: false,
        label: 'Charge Amt.',
        isShorted: true,
    },
]

// AGING DOS LIST

export const AgingDOSHeadCell = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: true,
    },
    {
        id: 'First Name',
        numeric: true,
        disablePadding: false,
        label: 'First Name',
        isShorted: true,
    },
    {
        id: 'Last Name',
        numeric: true,
        disablePadding: false,
        label: 'Last Name',
        isShorted: true,
    },
    {
        id: 'Patient ID',
        numeric: true,
        disablePadding: false,
        label: 'Patient ID',
        isShorted: true,
    },
    {
        id: 'DOS',
        numeric: true,
        disablePadding: false,
        label: 'DOS',
        isShorted: true,
    },
    {
        id: 'Provider',
        numeric: true,
        disablePadding: false,
        label: 'Provider',
        isShorted: true,
    },
    {
        id: 'Primary Insurance',
        numeric: true,
        disablePadding: false,
        label: 'Primary Insurance',
        isShorted: true,
    },
    {
        id: 'Procedure',
        numeric: true,
        disablePadding: false,
        label: 'Procedure',
        isShorted: false,
    },

    {
        id: 'Charge Amt.',
        numeric: true,
        disablePadding: false,
        label: 'Charge Amt.',
        isShorted: true,
    },
    {
        id: 'Date of Submission',
        numeric: true,
        disablePadding: false,
        label: 'Date of Submission',
        isShorted: true,
    },
    {
        id: '0-30',
        numeric: true,
        disablePadding: false,
        label: '0-30',
        isShorted: true,
    },
    {
        id: '31-60',
        numeric: true,
        disablePadding: false,
        label: '31-60',
        isShorted: true,
    },
    {
        id: '61-90',
        numeric: true,
        disablePadding: false,
        label: '61-90',
        isShorted: true,
    },
    {
        id: '91-120',
        numeric: true,
        disablePadding: false,
        label: '91-120',
        isShorted: true,
    },
    {
        id: '121-150',
        numeric: true,
        disablePadding: false,
        label: '121-150',
        isShorted: true,
    },
    {
        id: '151-180',
        numeric: true,
        disablePadding: false,
        label: '151-180',
        isShorted: false,
    },
    {
        id: '180+',
        numeric: true,
        disablePadding: false,
        label: '180+',
        isShorted: true,
    },
    {
        id: 'Total',
        numeric: true,
        disablePadding: false,
        label: 'Total',
        isShorted: true,
    },
]

// Hepl Head Cell
export const ProblemLogHeadCell = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },
    // {
    //     id: "Dos",
    //     numeric: true,
    //     disablePadding: false,
    //     label: "Dos",
    //     isShorted: true
    // },
    // {
    //     id: "Patient Id",
    //     numeric: true,
    //     disablePadding: false,
    //     label: "Patient Id",
    //     isShorted: true
    // },
    {
        id: 'Patient',
        numeric: true,
        disablePadding: false,
        label: 'Patient Name',
        isShorted: false,
    },
    // {
    //     id: "Provider Name",
    //     numeric: true,
    //     disablePadding: false,
    //     label: "Provider Name",
    //     isShorted: false
    // },
    // {
    //     id: "Re submitted Remarks",
    //     numeric: true,
    //     disablePadding: false,
    //     label: "Re submitted Remarks",
    //     isShorted: false
    // },
    {
        id: 'Remarks',
        numeric: true,
        disablePadding: false,
        label: 'Remarks',
        isShorted: false,
    },
    {
        id: 'Status',
        numeric: true,
        disablePadding: false,
        label: 'Status',
        isShorted: false,
    },
    {
        id: 'Action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]

// Hepl Head Cell
export const HeplHeadCell = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },
    {
        id: 'title',
        numeric: true,
        disablePadding: false,
        label: 'Title',
        isShorted: true,
    },
    {
        id: 'description',
        numeric: true,
        disablePadding: false,
        label: 'Description',
        isShorted: true,
    },
    {
        id: 'File',
        numeric: true,
        disablePadding: false,
        label: 'File',
        isShorted: false,
    },
    {
        id: 'Action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]

// Notification Header

export const NotificationHeadCell = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },
    {
        id: 'title',
        numeric: true,
        disablePadding: false,
        label: 'Title',
        isShorted: false,
    },
    {
        id: 'description',
        numeric: true,
        disablePadding: false,
        label: 'Description',
        isShorted: false,
    },
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: 'Date',
        isShorted: false,
    },
    {
        id: 'Action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]

// Reports Summary DOS
export const SummartDOSHeadCell = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: true,
    },
    {
        id: 'Insurance',
        numeric: true,
        disablePadding: false,
        label: 'Insurance',
        isShorted: true,
    },
    {
        id: '0-30',
        numeric: true,
        disablePadding: false,
        label: '0-30',
        isShorted: true,
    },
    {
        id: '31-60',
        numeric: true,
        disablePadding: false,
        label: '31-60',
        isShorted: true,
    },
    {
        id: '61-90',
        numeric: true,
        disablePadding: false,
        label: '61-90',
        isShorted: true,
    },
    {
        id: '91-120',
        numeric: true,
        disablePadding: false,
        label: '91-120',
        isShorted: true,
    },
    {
        id: '121-150',
        numeric: true,
        disablePadding: false,
        label: '121-150',
        isShorted: true,
    },
    {
        id: '151-180',
        numeric: true,
        disablePadding: false,
        label: '151-180',
        isShorted: false,
    },
    {
        id: '180+',
        numeric: true,
        disablePadding: false,
        label: '180+',
        isShorted: true,
    },
    {
        id: 'Total',
        numeric: true,
        disablePadding: false,
        label: 'Total',
        isShorted: true,
    },
]

// Claims list
export const claimsGroupHeadCells = [
    {
        id: 'Claim #',
        numeric: true,
        disablePadding: true,
        label: 'Claim# / Appt Number',
        isShorted: false,
    },
    {
        id: 'Invoice#',
        numeric: true,
        disablePadding: false,
        label: 'Invoice#',
        isShorted: false,
    },
    {
        id: 'CLAIM TYPE',
        numeric: true,
        disablePadding: false,
        label: 'Claim Type',
        isShorted: false,
    },
    {
        id: 'Clearing House',
        numeric: true,
        disablePadding: false,
        label: 'Clearing House',
        isShorted: false,
    },
    {
        id: 'Chart No.',
        numeric: true,
        disablePadding: false,
        label: 'Chart No.',
        isShorted: false,
    },
    {
        id: 'Patient DOB',
        numeric: true,
        disablePadding: false,
        label: 'Patient(DOB)',
        isShorted: false,
    },
    {
        id: 'Patient Name',
        numeric: true,
        disablePadding: false,
        label: 'Patient Name',
        isShorted: false,
    },
    {
        id: 'Billing Provider',
        numeric: true,
        disablePadding: false,
        label: 'Billing Provider',
        isShorted: false,
    },
    {
        id: 'Referring Provider',
        numeric: true,
        disablePadding: false,
        label: 'Referring Provider',
        isShorted: false,
    },
    {
        id: 'Payer',
        numeric: true,
        disablePadding: false,
        label: 'Payer',
        isShorted: false,
    },
    {
        id: 'Insurance Plan',
        numeric: true,
        disablePadding: false,
        label: 'Insurance Plan',
        isShorted: false,
    },
    {
        id: 'Insurance Type',
        numeric: true,
        disablePadding: false,
        label: 'Insurance Type',
        isShorted: false,
    },
    {
        id: 'Appointment No.',
        numeric: true,
        disablePadding: false,
        label: 'Appointment No.',
        isShorted: false,
    },
    {
        id: 'DOS(From-To)',
        numeric: true,
        disablePadding: false,
        label: `DOS ( From ~ To )`,
        isShorted: false,
    },
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: 'Claim( Submission ) Date',
        isShorted: false,
    },
    {
        id: 'Claim Status',
        numeric: true,
        disablePadding: false,
        label: 'Claim Status',
        isShorted: false,
    },
    {
        id: 'Claim Ack.Status',
        numeric: true,
        disablePadding: false,
        label: 'Claim( Ack ) Status',
        isShorted: false,
    },
    {
        id: 'CaseType',
        numeric: true,
        disablePadding: false,
        label: 'Case Type',
        isShorted: false,
    },
    {
        id: 'Case Name',
        numeric: true,
        disablePadding: false,
        label: 'Case Name',
        isShorted: false,
    },
    {
        id: 'ID/Policy',
        numeric: true,
        disablePadding: false,
        label: 'ID/Policy',
        isShorted: false,
    },
    {
        id: 'Location',
        numeric: true,
        disablePadding: false,
        label: 'Location',
        isShorted: false,
    },
    {
        id: 'CPT',
        numeric: true,
        disablePadding: false,
        label: 'CPT',
        isShorted: false,
    },
    {
        id: 'ICD',
        numeric: true,
        disablePadding: false,
        label: 'ICD',
        isShorted: false,
    },
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: 'Modifier($)',
        isShorted: false,
    },
    {
        id: 'Charges ($)',
        numeric: true,
        disablePadding: false,
        label: 'Charges($)',
        isShorted: false,
    },
    {
        id: 'Payment($)',
        numeric: true,
        disablePadding: false,
        label: 'Payment($)',
        isShorted: false,
    },
    {
        id: 'Adjusted($)',
        numeric: true,
        disablePadding: false,
        label: 'Adjusted($)',
        isShorted: false,
    },
    {
        id: 'Patient Bal.($)',
        numeric: true,
        disablePadding: false,
        label: 'PatientBal($)',
        isShorted: false,
    },
    // {
    //     id: 'Ins. Bal.($)',
    //     numeric: true,
    //     disablePadding: false,
    //     label: 'Ins.Bal($)',
    //     isShorted: false,
    // },
    {
        id: 'Remittance(Code)',
        numeric: true,
        disablePadding: false,
        label: 'Remittance(Code)',
        isShorted: false,
    },
    // {
    //     id: 'Batch',
    //     numeric: true,
    //     disablePadding: false,
    //     label: 'Batch',
    //     isShorted: false,
    // },
    // {
    //     id: 'User',
    //     numeric: true,
    //     disablePadding: false,
    //     label: 'User',
    //     isShorted: false,
    // },
    {
        id: 'Action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
    // {
    //     id: 'Type',
    //     numeric: true,
    //     disablePadding: false,
    //     label: 'Type',
    //     isShorted: false,
    // },
]

// claims Details HeadCells

export const claimsDetailsHeadCells = [
    {
        id: 'Invoice/Claim #',
        numeric: false,
        disablePadding: true,
        label: 'Invoice/Claim #',
        isShorted: true,
    },
    {
        id: 'DOS From',
        numeric: false,
        disablePadding: false,
        label: 'DOS From',
        isShorted: true,
    },
    {
        id: 'DOS To',
        numeric: false,
        disablePadding: false,
        label: 'DOS To',
        isShorted: true,
    },
    {
        id: 'CPT',
        numeric: false,
        disablePadding: false,
        label: 'CPT',
        isShorted: false,
    },
    {
        id: 'Charge ($)',
        numeric: true,
        disablePadding: false,
        label: 'Charge ($)',
        isShorted: true,
    },
    {
        id: 'Credited ($)',
        numeric: true,
        disablePadding: false,
        label: 'Credited ($)',
        isShorted: false,
    },
    {
        id: 'Balance ($)',
        numeric: true,
        disablePadding: false,
        label: 'Balance ($)',
        isShorted: false,
    },
    {
        id: 'Copay($)',
        numeric: true,
        disablePadding: false,
        label: 'Copay($)',
        isShorted: false,
    },
    {
        id: 'Priority',
        numeric: false,
        disablePadding: false,
        label: 'Priority',
        isShorted: false,
    },
    {
        id: 'Status',
        numeric: false,
        disablePadding: false,
        label: 'Status',
        isShorted: false,
    },
    {
        id: 'Type',
        numeric: false,
        disablePadding: false,
        label: 'Type',
        isShorted: false,
    },
    {
        id: 'Date',
        numeric: false,
        disablePadding: false,
        label: 'Date',
        isShorted: false,
    },
    {
        id: 'Activity User',
        numeric: false,
        disablePadding: false,
        label: 'Activity User',
        isShorted: false,
    },
    {
        id: 'Remit.Code',
        numeric: false,
        disablePadding: false,
        label: 'Remit.Code',
        isShorted: false,
    },
    {
        id: 'Notes',
        numeric: false,
        disablePadding: false,
        label: 'Notes',
        isShorted: false,
    },
    {
        id: 'Plan',
        numeric: false,
        disablePadding: false,
        label: 'Plan',
        isShorted: false,
    },
]

// provider Details HeadCell
export const providerDetailsHeadCells = [
    {
        id: 'Organization Name',
        numeric: true,
        disablePadding: true,
        label: 'Organization Name',
        isShorted: true,
    },
    {
        id: 'Provider Type',
        numeric: true,
        disablePadding: false,
        label: 'Provider Type',
        isShorted: false,
    },
    {
        id: 'Tax Id',
        numeric: true,
        disablePadding: false,
        label: 'Tax Id',
        isShorted: false,
    },
]

// Roles and Permission listing

export const RolePermissionTeamHeadCells = [
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: '#',
        isShorted: false,
    },
    {
        id: 'roleName',
        numeric: false,
        disablePadding: false,
        label: 'Role Name',
        isShorted: true,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]

// Clinic Payment Gateway
export const clinicPaymentGateWayCells = [
    {
        id: '',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: true,
    },
    {
        id: 'type',
        numeric: true,
        disablePadding: false,
        label: 'Name',
        isShorted: false,
    },
    {
        id: 'secret_key',
        numeric: true,
        disablePadding: false,
        label: 'Secret Key',
        isShorted: false,
    },
    {
        id: 'public_key',
        numeric: true,
        disablePadding: false,
        label: 'Public Key',
        isShorted: false,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
    },
]

// provider Document's List
export const ProviderDocumentHeadCells = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },

    {
        id: 'Document Type ',
        numeric: true,
        disablePadding: false,
        label: 'Document Type ',
        isShorted: true,
    },
    {
        id: 'File Name  ',
        numeric: true,
        disablePadding: false,
        label: 'File Name  ',
        isShorted: true,
    },
    {
        id: 'Issue Date  ',
        numeric: true,
        disablePadding: false,
        label: 'Issue Date  ',
        isShorted: true,
    },
    {
        id: 'Expiration Date  ',
        numeric: true,
        disablePadding: false,
        label: 'Expiration Date  ',
        isShorted: true,
    },
    {
        id: 'Status',
        numeric: true,
        disablePadding: false,
        label: 'Status',
        isShorted: false,
    },
    {
        id: 'Attachment ',
        numeric: true,
        disablePadding: false,
        label: 'Attachment ',
        isShorted: false,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]
// Provider Assiciation List
export const ProviderAssocitaionHeadCells = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },

    {
        id: 'Insurance Name',
        numeric: true,
        disablePadding: false,
        label: 'Insurance Name',
        isShorted: true,
    },
    {
        id: 'Issue Date',
        numeric: true,
        disablePadding: false,
        label: 'Issue Date',
        isShorted: true,
    },
    {
        id: 'Expiration Date',
        numeric: true,
        disablePadding: false,
        label: 'Expiration Date',
        isShorted: true,
    },
    {
        id: 'Status',
        numeric: true,
        disablePadding: false,
        label: 'Status',
        isShorted: false,
    },

    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]

// Provider Associtaion Reply HeadCells
export const ProviderAssocitaionReplyHeadCells = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },

    {
        id: 'Created-At',
        numeric: true,
        disablePadding: false,
        label: 'Created-At',
        isShorted: true,
    },
    {
        id: 'Description   ',
        numeric: true,
        disablePadding: false,
        label: 'Description   ',
        isShorted: true,
    },
    {
        id: 'Updated-At',
        numeric: true,
        disablePadding: false,
        label: 'Updated-At',
        isShorted: false,
    },
    {
        id: 'attachment',
        numeric: true,
        disablePadding: false,
        label: 'Attachment',
        isShorted: false,
    },
]

// Service order list
export const ProviderServiceOrderHeadCells = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },

    {
        id: 'Compliance Issue Number',
        numeric: true,
        disablePadding: false,
        label: 'Compliance Issue Number',
        isShorted: true,
    },
    {
        id: 'Description    ',
        numeric: true,
        disablePadding: false,
        label: 'Description    ',
        isShorted: true,
    },
    {
        id: 'DocType',
        numeric: true,
        disablePadding: false,
        label: 'DocType',
        isShorted: true,
    },
    {
        id: 'Raised By ',
        numeric: true,
        disablePadding: false,
        label: 'Raised By ',
        isShorted: false,
    },
    {
        id: 'Status',
        numeric: true,
        disablePadding: false,
        label: 'Status',
        isShorted: false,
    },
    {
        id: 'Creation Date ',
        numeric: true,
        disablePadding: false,
        label: 'Creation Date',
        isShorted: false,
    },
    {
        id: 'Closed Date ',
        numeric: true,
        disablePadding: false,
        label: 'Closed Date',
        isShorted: false,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: true,
        label: 'Action',
        isShorted: false,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: true,
        label: '',
        isShorted: false,
    },
]

// Provider Settelment Insurance HeadCells
export const PaymentSettelmentInsuranceHeadCells = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },
    {
        id: 'Insurance name',
        numeric: true,
        disablePadding: false,
        label: 'Insurance name',
        isShorted: true,
    },
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: '',
        isShorted: false,
    },
]

// Paymnet settlemnet list headercells
export const PaymnetSettlementHeadCells = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },

    {
        id: 'Cpt Code',
        numeric: true,
        disablePadding: false,
        label: 'Cpt Code',
        isShorted: true,
    },
    // {
    //     id: "Description   ",
    //     numeric: true,
    //     disablePadding: false,
    //     label: "Description   ",
    //     isShorted: true
    // },
    {
        id: 'Price',
        numeric: true,
        disablePadding: false,
        label: 'Price',
        isShorted: false,
    },
    {
        id: 'Status',
        numeric: true,
        disablePadding: false,
        label: 'Status',
        isShorted: false,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
    },
]

//  provider List Head cells
export const providerHeadCells = [
    {
        id: '#',
        numeric: false,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },
    {
        id: `first_name`,
        numeric: false,
        disablePadding: true,
        label: 'Name',
        isShorted: true,
    },

    {
        id: 'email',
        numeric: true,
        disablePadding: false,
        label: 'E-mail Address',
        isShorted: true,
    },
    {
        id: 'Status',
        numeric: true,
        disablePadding: false,
        label: 'Status',
        isShorted: false,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
    },
]
//  patient List Head cells
export const PatientHeadCells = [
    {
        id: '#',
        numeric: false,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },
    {
        id: `first_name`,
        numeric: false,
        disablePadding: true,
        label: 'Name',
        isShorted: true,
    },
    {
        id: 'email',
        numeric: true,
        disablePadding: false,
        label: 'E-mail Address',
        isShorted: true,
    },
    {
        id: 'Status',
        numeric: true,
        disablePadding: false,
        label: 'Status',
        isShorted: false,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]
//  AppointmentTypeHeadCells List Head cells
export const AppointmentTypeHeadCells = [
    {
        id: '#',
        numeric: false,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },
    {
        id: `type`,
        numeric: false,
        disablePadding: true,
        label: 'Appointments',
        isShorted: true,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
    },
]
export const LocationHeadCells = [
    {
        id: '#',
        numeric: false,
        disablePadding: true,
        label: '#',
        isShorted: true,
    },
    {
        id: `branchName`,
        numeric: false,
        disablePadding: true,
        label: 'Branch Name',
        isShorted: false,
    },
    {
        id: 'country',
        numeric: true,
        disablePadding: false,
        label: 'Country',
        isShorted: false,
    },
    {
        id: 'state',
        numeric: true,
        disablePadding: false,
        label: 'State',
        isShorted: false,
    },
    {
        id: 'city',
        numeric: true,
        disablePadding: false,
        label: 'City',
        isShorted: false,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]
//  e-progess List Head cells
export const E_progessHeadCells = [
    {
        id: '#',
        numeric: false,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },
    {
        id: `Strength`,
        numeric: false,
        disablePadding: true,
        label: 'Strength / Frequency',
        isShorted: true,
    },
    {
        id: `Precaution`,
        numeric: false,
        disablePadding: true,
        label: 'Precaution',
        isShorted: true,
    },
    {
        id: `Provider Name`,
        numeric: false,
        disablePadding: true,
        label: 'Provider Name',
        isShorted: true,
    },
    {
        id: `Appointment No.`,
        numeric: false,
        disablePadding: true,
        label: 'Appointment No.',
        isShorted: true,
    },
    {
        id: `Appointment Date`,
        numeric: false,
        disablePadding: true,
        label: 'Appointment Date',
        isShorted: true,
    },
    {
        id: `Appointment Time`,
        numeric: false,
        disablePadding: true,
        label: 'Appointment Time',
        isShorted: true,
    },
]

//  Notes List Head cells
export const NotesHeadCells = [
    {
        id: '#',
        numeric: false,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },
    {
        id: `notes`,
        numeric: false,
        disablePadding: true,
        label: 'Note',
        isShorted: true,
    },
    {
        id: `first_name`,
        numeric: false,
        disablePadding: true,
        label: 'Created By',
        isShorted: false,
    },
    {
        id: `createdAt`,
        numeric: false,
        disablePadding: true,
        label: 'Created Date',
        isShorted: false,
    },
    {
        id: `createdAt`,
        numeric: false,
        disablePadding: true,
        label: 'Created Time',
        isShorted: false,
    },
]
//  shared form List Head cells
export const FormSharedHeadCells = [
    {
        id: '#',
        numeric: false,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },
    {
        id: `form_title`,
        numeric: false,
        disablePadding: true,
        label: 'Form Assigned',
        isShorted: true,
    },
    {
        id: `createdAt`,
        numeric: false,
        disablePadding: true,
        label: 'Appointment Date',
        isShorted: false,
    },
    {
        id: `createdAt`,
        numeric: false,
        disablePadding: true,
        label: 'Appointment Time',
        isShorted: false,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]
// form history list head cells
export const FormHistoryHeadCells = [
    {
        id: '#',
        numeric: false,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },
    {
        id: `createdAt`,
        numeric: false,
        disablePadding: true,
        label: 'Date',
        isShorted: true,
    },
    {
        id: `createdAt`,
        numeric: false,
        disablePadding: true,
        label: 'Time',
        isShorted: false,
    },
    {
        id: `form_title`,
        numeric: false,
        disablePadding: true,
        label: 'Form Assigned',
        isShorted: false,
    },
    {
        id: `received_date`,
        numeric: false,
        disablePadding: true,
        label: 'Form Rec. Date',
        isShorted: false,
    },
    {
        id: `received_date`,
        numeric: false,
        disablePadding: true,
        label: 'Form Rec. Time',
        isShorted: false,
    },
    {
        id: `filledPercentage`,
        numeric: false,
        disablePadding: true,
        label: 'Filled Status',
        isShorted: false,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]
// form Reject list head cells
export const RejectFormHeadCells = [
    {
        id: '#',
        numeric: false,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },
    {
        id: `createdAt`,
        numeric: false,
        disablePadding: true,
        label: 'Date',
        isShorted: true,
    },
    {
        id: `createdAt`,
        numeric: false,
        disablePadding: true,
        label: 'Time',
        isShorted: false,
    },
    {
        id: `form_title`,
        numeric: false,
        disablePadding: true,
        label: 'Form Assigned',
        isShorted: false,
    },
    {
        id: `received_date`,
        numeric: false,
        disablePadding: true,
        label: 'Form Rec. Date',
        isShorted: false,
    },
    {
        id: `received_date`,
        numeric: false,
        disablePadding: true,
        label: 'Form Rec. Time',
        isShorted: false,
    },
    {
        id: `filledPercentage`,
        numeric: false,
        disablePadding: true,
        label: 'Filled Status',
        isShorted: false,
    },
]
// clinic Form Enum
export const clinicEnum = {
    clinic_name: '',
    first_name: '',
    last_name: '',
    email: '',
    designation: '',
    id: '1a',
    // address: "",
    // postal_code: "",
    // city: "",
    // country: "",
    // state: "",
    // npi_no: "",
    // taxonomy: ""
}
export const clinicBranchEnum = {
    // contact: "",
    branch_name: '',
    email: '',
    NPI_number: '',
    taxonomy: '',
    fed_id: '',
    office: '',
    fax: '',
    address: '',
    zip_code: '',
    city: '',
    country: '',
    state: '',
    tax_id: '',
    // mobile_without_code:""

    // apartment: "",
}

// Clinic Branch Table
export const clinicBranchHeadCells = [
    {
        id: '',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },
    {
        id: 'branchName',
        numeric: true,
        disablePadding: true,
        label: 'Branch Name',
        isShorted: true,
    },
    {
        id: 'email',
        numeric: true,
        disablePadding: false,
        label: 'E-mail Address',
        isShorted: true,
    },
    {
        id: 'address',
        numeric: true,
        disablePadding: false,
        label: 'Address',
        isShorted: false,
    },
    {
        id: 'city',
        numeric: true,
        disablePadding: false,
        isShorted: false,
        label: 'City',
    },
    {
        id: 'Status',
        numeric: true,
        disablePadding: false,
        label: 'Status',
        isShorted: false,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]

// Patient Documnet
export const PatientDocumnetHeadCells = [
    {
        id: '',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },
    {
        id: 'title',
        numeric: true,
        disablePadding: false,
        label: 'Title',
        isShorted: true,
    },
    {
        id: 'description',
        numeric: true,
        disablePadding: false,
        label: 'Description',
        isShorted: false,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]

export const patientDocumnetEnum = {
    title: '',
    description: '',
}

//  Patients Progress Notes

export const PatientProgressNoteHeadCells = [
    {
        id: '',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: true,
    },
    {
        id: 'appointment_number',
        numeric: true,
        disablePadding: false,
        label: 'Appointment No.',
        isShorted: true,
    },
    {
        id: 'provider_first_name',
        numeric: true,
        disablePadding: false,
        label: 'Provider',
        isShorted: true,
    },
    {
        id: 'startDateTime',
        numeric: true,
        disablePadding: false,
        label: 'Appointment Date	',
        isShorted: true,
    },
    {
        id: 'startDateTime',
        numeric: true,
        disablePadding: false,
        label: 'Appointment Time	',
        isShorted: true,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]

// Patient VisitHistory

export const PatientVisitHistoryHeadCells = [
    {
        id: '',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },
    {
        id: 'doctor_name',
        numeric: true,
        disablePadding: false,
        label: 'Provider',
        isShorted: true,
    },
    {
        id: 'total_appointment',
        numeric: true,
        disablePadding: false,
        label: 'Total Appointments',
        isShorted: false,
    },
    {
        id: 'last_visit',
        numeric: true,
        disablePadding: false,
        label: 'Last Visit',
        isShorted: false,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]

export const PatientVisitHistoryDetailHeadCells = [
    {
        id: '',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },
    {
        id: 'appointment_number',
        numeric: true,
        disablePadding: false,
        label: 'Appointment No',
        isShorted: false,
    },
    {
        id: 'appointment_type',
        numeric: true,
        disablePadding: false,
        label: 'Appointment Type',
        isShorted: true,
    },
    {
        id: 'startDateTime',
        numeric: true,
        disablePadding: false,
        label: 'Appointment Date',
        isShorted: true,
    },
    {
        id: 'Appointment Time',
        numeric: true,
        disablePadding: false,
        label: 'Appointment Time',
        isShorted: true,
    },
    {
        id: 'status',
        numeric: true,
        disablePadding: false,
        label: 'Status',
        isShorted: false,
    },
]

// Patient Payment List
export const PatientPaymetnHeadCells = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: 'Status',
        isShorted: false,
    },
    {
        id: 'Payment Date',
        numeric: true,
        disablePadding: false,
        label: 'Payment Date',
        isShorted: true,
    },
    {
        id: 'Date Of Service',
        numeric: true,
        disablePadding: false,
        label: 'Date Of Service',
        isShorted: false,
    },
    {
        id: 'Type',
        numeric: true,
        disablePadding: false,
        label: 'Type',
        isShorted: false,
    },
    {
        id: 'Mode',
        numeric: true,
        disablePadding: false,
        label: 'Mode',
        isShorted: false,
    },
    {
        id: 'CC Mode	',
        numeric: true,
        disablePadding: false,
        label: 'CC Mode	',
        isShorted: false,
    },
    {
        id: 'Details#',
        numeric: true,
        disablePadding: false,
        label: 'Details#',
        isShorted: false,
    },
    {
        id: 'Paid By	',
        numeric: true,
        disablePadding: false,
        label: 'Paid By	',
        isShorted: false,
    },
    {
        id: 'Amount($)',
        numeric: true,
        disablePadding: false,
        label: 'Amount($)',
        isShorted: false,
    },
    {
        id: 'User',
        numeric: false,
        disablePadding: false,
        label: 'User',
        isShorted: false,
    },
]

// Clinic patient attachments

export const PatientAttachmentsHeadCells = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },
    {
        id: 'appointment_number',
        numeric: true,
        disablePadding: false,
        label: 'Appointment No.',
        isShorted: true,
    },
    {
        id: 'address',
        numeric: true,
        disablePadding: false,
        label: 'Provider',
        isShorted: false,
    },
    {
        id: 'startDateTime',
        numeric: true,
        disablePadding: false,
        label: 'Appointment Date',
        isShorted: false,
    },
    {
        id: 'startDateTime',
        numeric: true,
        disablePadding: false,
        label: 'Appointment Time',
        isShorted: false,
    },
    {
        id: 'action',
        numeric: false,
    },
]

// Clinic Appointment
export const AppointmentHeadCells = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: true,
    },
    {
        id: 'appointment_number',
        numeric: true,
        disablePadding: false,
        label: 'Appointment No.',
        isShorted: true,
    },
    {
        id: 'appointment_type',
        numeric: true,
        disablePadding: false,
        label: 'Appointment Type',
        isShorted: true,
    },
    {
        id: 'Patient Name',
        numeric: true,
        disablePadding: false,
        label: 'Patient Name',
    },
    {
        id: 'startDateTime',
        numeric: true,
        disablePadding: false,
        label: 'Date',
        isShorted: true,
    },
    {
        id: 'startDateTime',
        numeric: true,
        disablePadding: false,
        label: 'Time',
        isShorted: true,
    },
    {
        id: 'status',
        numeric: true,
        disablePadding: false,
        label: 'Status',
        isShorted: true,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]

// group appointment patient list
export const groupAppointmentHeadCells = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: true,
    },
    {
        id: 'Name',
        numeric: true,
        disablePadding: false,
        label: 'Name',
        isShorted: true,
    },
    {
        id: 'Email',
        numeric: true,
        disablePadding: false,
        label: 'Email',
        isShorted: true,
    },

    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]

// Clinic  Schedule Appointment
export const ScheduleAppointmentHeadCells = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: true,
    },
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: 'Provider Name',
        isShorted: false,
    },
    {
        id: 'VisitType',
        numeric: true,
        disablePadding: false,
        label: 'VisitType',
        isShorted: false,
    },
    {
        id: 'Location',
        numeric: true,
        disablePadding: false,
        label: 'Location',
        isShorted: false,
    },
    {
        id: 'Availability',
        numeric: true,
        disablePadding: false,
        label: 'Availability',
        isShorted: false,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]

// Optnal Appoint slote Header

export const OptnalScheduleAppointmentHeadCells = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },
    {
        id: 'user',
        numeric: true,
        disablePadding: false,
        label: 'Patient Name',
        isShorted: true,
    },
    {
        id: 'Appointment Date',
        numeric: true,
        disablePadding: false,
        label: 'Appointment Date',
        isShorted: false,
    },
    {
        id: 'Time',
        numeric: true,
        disablePadding: false,
        label: 'Time',
        isShorted: false,
    },
]

// tamplate form

export const TamplateLibraryHeadCells = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },
    {
        id: 'form_title',
        numeric: true,
        disablePadding: false,
        label: 'Template Name',
        isShorted: true,
    },
    {
        id: 'category',
        numeric: true,
        disablePadding: false,
        label: 'Category',
        isShorted: false,
    },
    {
        id: 'Status',
        numeric: true,
        disablePadding: false,
        label: 'Status',
        isShorted: false,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]

export const DraftsHeadCells = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: 'Template Name',
        isShorted: true,
    },

    {
        id: 'Category',
        numeric: true,
        disablePadding: false,
        label: 'Category',
        isShorted: false,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]
export const selectCategoryListHeadCells = [
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: 'Template Name',
        isShorted: false,
    },

    {
        id: 'Category',
        numeric: true,
        disablePadding: false,
        label: 'Category',
        isShorted: true,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]
export const selecttemplateformListHeadCells = [
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: 'Template Name',
        isShorted: false,
    },

    {
        id: 'Category',
        numeric: true,
        disablePadding: false,
        label: 'Category',
        isShorted: true,
    },
]
export const FormCategoryHeadCells = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },

    {
        id: 'category',
        numeric: true,
        disablePadding: false,
        label: 'Category',
        isShorted: true,
    },
    {
        id: 'Status',
        numeric: true,
        disablePadding: false,
        label: 'Status',
        isShorted: false,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]
export const NoteTypeHeadCells = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },

    {
        id: 'Note type',
        numeric: true,
        disablePadding: false,
        label: 'Note type',
        isShorted: true,
    },
    {
        id: 'Status',
        numeric: true,
        disablePadding: false,
        label: 'Status',
        isShorted: false,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]

export const ApiStatus = {
    success: 200,
    serverError: 'Server Error',
}

export const inValidApiHit = {
    success: 400,
    serverError: 'Please Select Patient',
}

export const claimsFormModel = {
    business: null,
    batch: '',
    patient: null,
    caseType: '',
    claimType: '',
    caseName: '',
    claimSubmissionTo: moment().startOf('day'),
    claimSubmissionFrom: moment().startOf('month'),
    claim: '',
    dosFrom: null,
    dosTo: null,
    ediPlayer: '',
    locationId: null,
    invoice: '',
    trackerId: '',
    insuranceOrder: '',
    billingProvider: null,
    renderingProvider: '',
    planType: '',
    planCategory: '',
    clearingHouse: '',
    summaryStatus: '',
    claimStatus: '',
    cptCodes: null,
    icdCodes: null,
}
// Billing team

export const BillingTeamHeadCell = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },
    {
        id: 'name',
        numeric: true,
        disablePadding: false,
        label: 'Team Name',
        isShorted: true,
    },
    {
        id: 'ClinicsAssigned',
        numeric: true,
        disablePadding: false,
        label: 'Clinics Assigned',
        isShorted: false,
    },
    {
        id: 'Team Members',
        numeric: true,
        disablePadding: false,
        label: 'Team Members',
        isShorted: false,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]
export const clinicinbillingsetcionHeadCell = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },
    {
        id: 'clinic_name',
        numeric: true,
        disablePadding: false,
        label: 'Name',
        isShorted: true,
    },
    {
        id: 'ClinicsAssigned',
        numeric: true,
        disablePadding: false,
        label: 'Email',
        isShorted: true,
    },
]
// Billing team2

export const BillingnTeamHeadCell = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },
    {
        id: 'name',
        numeric: true,
        disablePadding: false,
        label: 'Team Name',
        isShorted: true,
    },
    {
        id: 'ClinicsAssigned',
        numeric: true,
        disablePadding: false,
        label: 'Clinics Assigned',
        isShorted: false,
    },
    {
        id: 'Team Members',
        numeric: true,
        disablePadding: false,
        label: 'Team Members',
        isShorted: false,
    },
]

// billing Team Member Header cell
export const BillingTeamMemberHeadCell = [
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: 'Name',
        isShorted: true,
    },
    {
        id: 'EmailId',
        numeric: true,
        disablePadding: false,
        label: 'Email Id',
        isShorted: false,
    },
    {
        id: 'AssignedRoles',
        numeric: true,
        disablePadding: false,
        label: 'Assigned Roles',
        isShorted: false,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]

//  Checkout Appointment Details Patient Checkout List

export const PatientCheckoutListHeadCell = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: true,
    },
    {
        id: 'startDateTime',
        numeric: true,
        disablePadding: false,
        label: 'Date',
        isShorted: true,
    },
    {
        id: 'startDateTime',
        numeric: true,
        disablePadding: false,
        label: 'Time',
        isShorted: true,
    },
    {
        id: 'appointment_number',
        numeric: true,
        disablePadding: false,
        label: 'Appointment ID',
        isShorted: true,
    },
    {
        id: 'patientData[patientId]',
        numeric: true,
        disablePadding: false,
        label: 'Patient ID',
        isShorted: false,
    },
    {
        id: 'name',
        numeric: true,
        disablePadding: false,
        label: 'Name',
        isShorted: false,
    },
    {
        id: 'checkInTime',
        numeric: true,
        disablePadding: false,
        label: 'Check-In Time',
        isShorted: false,
    },
    {
        id: 'checkout ',
        numeric: true,
        disablePadding: false,
        label: 'Check-Out ',
        isShorted: false,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]

//  checkedOut Tabel header

export const CheckedoutListHeadCell = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: true,
    },
    {
        id: 'startDateTime',
        numeric: true,
        disablePadding: false,
        label: 'Date',
        isShorted: true,
    },
    {
        id: 'startDateTime',
        numeric: true,
        disablePadding: false,
        label: 'Time',
        isShorted: false,
    },
    {
        id: 'appointment_number',
        numeric: true,
        disablePadding: false,
        label: 'Appointment ID',
        isShorted: false,
    },
    {
        id: 'patientId',
        numeric: true,
        disablePadding: false,
        label: 'Patient ID',
        isShorted: false,
    },
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: 'Patient Name',
        isShorted: false,
    },
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: 'Provider Name',
        isShorted: false,
    },
    {
        id: 'checkInTime',
        numeric: true,
        disablePadding: false,
        label: 'Check-Out Date ',
        isShorted: false,
    },
    {
        id: 'checkoutTime',
        numeric: true,
        disablePadding: false,
        label: 'Check-Out Time',
        isShorted: false,
    },
    {
        id: ' ',
        numeric: true,
        disablePadding: false,
        label: 'Generate Super Bill ',
        isShorted: false,
    },
]

// not Show

export const NotShowHeadCell = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: true,
    },
    {
        id: 'startDateTime',
        numeric: true,
        disablePadding: false,
        label: 'Date',
        isShorted: true,
    },
    {
        id: 'startDateTime',
        numeric: true,
        disablePadding: false,
        label: 'Time',
        isShorted: false,
    },
    {
        id: 'appointment_number',
        numeric: true,
        disablePadding: false,
        label: 'Appointment ID',
        isShorted: false,
    },
    {
        id: 'patientId',
        numeric: true,
        disablePadding: false,
        label: 'Patient ID',
        isShorted: false,
    },
    {
        id: 'name',
        numeric: true,
        disablePadding: false,
        label: 'Name',
        isShorted: false,
    },
    {
        id: 'checkInTime',
        numeric: true,
        disablePadding: false,
        label: 'Check-In(Time)',
        isShorted: false,
    },
    {
        id: 'checkoutTime',
        numeric: true,
        disablePadding: false,
        label: 'Check-Out(Time)',
        isShorted: false,
    },
    {
        id: 'chargePatient',
        numeric: true,
        disablePadding: false,
        label: 'Check-Out(Type)',
        isShorted: false,
    },
    {
        id: 'Action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]

// progress form
export const progressNoteHeadCells = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },
    {
        id: 'form_title',
        numeric: true,
        disablePadding: false,
        label: 'Template Name',
        isShorted: true,
    },
    {
        id: 'Status',
        numeric: true,
        disablePadding: false,
        label: 'Status',
        isShorted: false,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]

export const apppointmentTypeHeadCells = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: false,
    },
    {
        id: 'type',
        numeric: true,
        disablePadding: false,
        label: 'Appointment Type',
        isShorted: true,
    },
    {
        id: 'duration',
        numeric: true,
        disablePadding: false,
        label: 'Duration (Min.)',
        isShorted: false,
    },
    {
        id: 'Status',
        numeric: true,
        disablePadding: false,
        label: 'Status',
        isShorted: false,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]

// insorance

export const InsuranceListHeadCells = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: true,
    },
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: 'Insurance Name',
        isShorted: false,
    },
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: 'CP Id',
        isShorted: false,
    },
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: 'Payer Id',
        isShorted: false,
    },
    {
        id: 'Insurance Address',
        numeric: true,
        disablePadding: false,
        label: 'Insurance Address',
        isShorted: true,
    },
    {
        id: 'Status',
        numeric: true,
        disablePadding: false,
        label: '',
        isShorted: true,
    },
    {
        id: 'Status',
        numeric: true,
        disablePadding: false,
        label: '',
        isShorted: true,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]

// Plan Type
export const PlanTypeData = [
    { code: '11', description: 'Other Non-Federal Programs' },
    { code: '12', description: 'Preferred Provider Organization (PPO)' },
    { code: '13', description: 'Point of Service (POS)' },
    { code: '14', description: 'Exclusive Provider Organization (EPO)' },
    { code: '15', description: 'Indemnity Insurance' },
    { code: '16', description: 'Health Maintenance Organization (HMO) Medicare Risk' },
    { code: '17', description: 'Dental Maintenance Organization' },
    { code: 'AM', description: 'Automobile Medical' },
    { code: 'BL', description: 'Blue Cross/Blue Shield' },
    { code: 'CH', description: 'Champus' },
    { code: 'CI', description: 'Commercial' },
    { code: 'DS', description: 'Disability' },
    { code: 'FI', description: 'Federal Employees Program' },
    { code: 'HM', description: 'Health Maintenance Organization' },
    { code: 'LM', description: 'Liability Medical' },
    { code: 'MA', description: 'Medicare Part A' },
    { code: 'MB', description: 'Medicare Part B' },
    { code: 'MC', description: 'Medicaid' },
    { code: 'OF', description: 'Other Federal Program' },
    { code: 'TV', description: 'Title V' },
    { code: 'VA', description: 'Veterans Affairs Plan' },
    { code: 'WC', description: "Workers' Compensation Health Claim" },
    { code: 'ZZ', description: 'Mutually Defined' },
]

// cpt code
export const cptListHeadCells = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: true,
    },
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: 'Code',
        isShorted: false,
    },
    {
        id: 'Description',
        numeric: true,
        disablePadding: false,
        label: 'Description',
        isShorted: true,
    },
    {
        id: 'Pricing',
        numeric: true,
        disablePadding: false,
        label: 'Pricing',
        isShorted: true,
    },
    {
        id: 'Status',
        numeric: true,
        disablePadding: false,
        label: 'Status',
        isShorted: true,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]
// icd code
export const icdListHeadCells = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: true,
    },
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: 'Code',
        isShorted: false,
    },
    {
        id: 'Category',
        numeric: true,
        disablePadding: false,
        label: 'Category',
        isShorted: true,
    },
    {
        id: 'Description',
        numeric: true,
        disablePadding: false,
        label: 'Description',
        isShorted: true,
    },
    {
        id: 'Status',
        numeric: true,
        disablePadding: false,
        label: 'Status',
        isShorted: true,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]
// modifier code
export const modifierListHeadCells = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: '#',
        isShorted: true,
    },
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: 'Code',
        isShorted: false,
    },
    {
        id: 'Description',
        numeric: true,
        disablePadding: false,
        label: 'Description',
        isShorted: true,
    },
    {
        id: 'Status',
        numeric: true,
        disablePadding: false,
        label: 'Status',
        isShorted: true,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]

export const GenerateSuperBillHeadCells = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: 'CPT(s)',
        isShorted: true,
    },
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: 'Modifier(s)',
        isShorted: false,
    },
    {
        id: 'DescriICD(s)ption',
        numeric: true,
        disablePadding: false,
        label: 'ICD(s)',
        isShorted: true,
    },
    {
        id: 'Linked ICD(s)',
        numeric: true,
        disablePadding: false,
        label: 'Linked~ICD(s)',
        isShorted: true,
    },
    // {
    //     id: '+',
    //     numeric: true,
    //     disablePadding: false,
    //     label: '+',
    //     isShorted: false,
    // },
    // {
    //     id: 'POS',
    //     numeric: true,
    //     disablePadding: false,
    //     label: 'POS',
    //     isShorted: false,
    // },
    {
        id: 'Qty',
        numeric: true,
        disablePadding: false,
        label: 'Quantity',
        isShorted: false,
    },
    {
        id: 'Charge($)',
        numeric: true,
        disablePadding: false,
        label: 'Charge($)',
        isShorted: false,
    },
    {
        id: ' Total ($)',
        numeric: true,
        disablePadding: false,
        label: 'Total($)',
        isShorted: false,
    },

    // {
    //     id: ' Pre Auth',
    //     numeric: true,
    //     disablePadding: false,
    //     label: 'Pre~Auth',
    //     isShorted: false,
    // },
    // {
    //     id: 'NCS NDC	',
    //     numeric: true,
    //     disablePadding: false,
    //     label: 'NCS	NDC	',
    //     isShorted: false,
    // },
    {
        id: 'Order	',
        numeric: true,
        disablePadding: false,
        label: 'Order',
        isShorted: false,
    },
]

export const ackowledgementStatus = [
    { name: 'CH ACCEPTED', id: 'CH_ACCEPTED' },
    { name: 'CH REJECTED', id: 'CH_REJECTED' },
    { name: 'CH ACCEPTED WITH ERROR', id: 'CH_ACCEPTED_WITH_ERROR' },
    { name: 'SEND TO PAYER', id: 'SEND_TO_PAYER' },
    { name: 'PAYER RECEIVED', id: 'PAYER_RECEIVED' },
    { name: 'PAYER ACCEPTED', id: 'PAYER_ACCEPTED' },
    { name: 'PAYER REJECTED', id: 'PAYER_REJECTED' },
]

export const claimStatus = [
    { name: 'PATIENT RESPONSIBLE', id: 'PATIENT_RESPONSIBLE' },
    { name: 'BILLED TO PATIENT', id: 'BILLED_TO_PATIENT' },
    { name: 'CLAIM GENRATED', id: 'CLAIM_GENRATED' },
    { name: 'SEND ON PAPER', id: 'SEND_ON_PAPER' },
    { name: 'SEND TO CH', id: 'SEND_TO_CH' },
    { name: 'CH SCRUB ERROR', id: 'CH_SCRUB_ERROR' },
    { name: 'CH CONFIRMED', id: 'CH_CONFIRMED' },
    { name: 'PAID', id: 'PAID' },
    { name: 'REJECTED', id: 'REJECTED' },
    { name: 'COMPLETED', id: 'COMPLETED' },
]
//  super bill list HeadCells

export const SuperBillHeadCells = [
    {
        id: 'Patient	',
        numeric: true,
        disablePadding: false,
        label: 'Patient',
        isShorted: false,
    },
    {
        id: 'branchName',
        numeric: true,
        disablePadding: false,
        label: 'Location',
        isShorted: true,
    },
    {
        id: '+',
        numeric: true,
        disablePadding: false,
        label: 'Billing Provider',
        isShorted: false,
    },
    {
        id: 'Claim Status',
        numeric: true,
        disablePadding: false,
        label: 'Claim Status',
        isShorted: false,
    },
    {
        id: 'Checkout Date',
        numeric: true,
        disablePadding: false,
        label: 'Checkout Date',
        isShorted: false,
    },
    {
        id: 'chartNo',
        numeric: true,
        disablePadding: false,
        label: 'Chart No',
        isShorted: false,
    },

    {
        id: 'Rendering Provider',
        numeric: true,
        disablePadding: false,
        label: 'Rendering Provider',
        isShorted: false,
    },
    {
        id: ' Pre Auth',
        numeric: true,
        disablePadding: false,
        label: 'Referring Provider',
        isShorted: false,
    },
    // {
    //     id: ' Pre Auth',
    //     numeric: true,
    //     disablePadding: false,
    //     label: 'Chart No',
    //     isShorted: false,
    // },
    {
        id: ' Patient DOB',
        numeric: true,
        disablePadding: false,
        label: 'Patient DOB',
        isShorted: false,
    },
    {
        id: 'Insurance Plan	',
        numeric: true,
        disablePadding: false,
        label: 'Insurance Plan',
        isShorted: false,
    },

    {
        id: 'Insurance Company	',
        numeric: true,
        disablePadding: false,
        label: 'Insurance Company',
        isShorted: false,
    },
    {
        id: 'Case Type	',
        numeric: true,
        disablePadding: false,
        label: 'Case Type',
        isShorted: false,
    },
    {
        id: 'Case Name	',
        numeric: true,
        disablePadding: false,
        label: 'Case Name',
        isShorted: false,
    },
    {
        id: 'Creation Date		',
        numeric: true,
        disablePadding: false,
        label: 'Creation Date	',
        isShorted: false,
    },
    {
        id: 'Admission Date		',
        numeric: true,
        disablePadding: false,
        label: 'Admission Date	',
        isShorted: false,
    },
    {
        id: '	Discharge Date	',
        numeric: true,
        disablePadding: false,
        label: '	Discharge Date',
        isShorted: false,
    },
    {
        id: 'Appointment No.',
        numeric: true,
        disablePadding: false,
        label: 'Appointment No.',
        isShorted: false,
    },
    {
        id: 'DOS FROM	',
        numeric: true,
        disablePadding: false,
        label: 'DOS(FROM)',
        isShorted: false,
    },
    {
        id: 'DOS TO	',
        numeric: true,
        disablePadding: false,
        label: 'DOS(TO)',
        isShorted: false,
    },
    {
        id: 'CPT Code	',
        numeric: true,
        disablePadding: false,
        label: 'CPT Code',
        isShorted: false,
    },
    {
        id: 'ICD Code	',
        numeric: true,
        disablePadding: false,
        label: 'ICD Code',
        isShorted: false,
    },
    {
        id: 'Modifier (s)	',
        numeric: true,
        disablePadding: false,
        label: 'Modifier(s)',
        isShorted: false,
    },
    {
        id: 'POS	Unit	',
        numeric: true,
        disablePadding: false,
        label: 'POS Unit',
        isShorted: false,
    },
    {
        id: 'Unit Charge	',
        numeric: true,
        disablePadding: false,
        label: 'UnitCharge',
        isShorted: false,
    },
    {
        id: 'total_amount',
        numeric: true,
        disablePadding: false,
        label: 'Total Charge($)',
        isShorted: false,
    },
    {
        id: 'ICD Type		',
        numeric: true,
        disablePadding: false,
        label: 'ICD Type	',
        isShorted: false,
    },
    {
        id: 'Status	',
        numeric: true,
        disablePadding: false,
        label: 'Status ',
        isShorted: false,
    },
    {
        id: 'Insurance Priority		',
        numeric: true,
        disablePadding: false,
        label: 'Insurance Priority	',
        isShorted: false,
    },
    {
        id: 'Hold Date		',
        numeric: true,
        disablePadding: false,
        label: 'Hold Reason',
        isShorted: false,
    },
    {
        id: 'Hold By		',
        numeric: true,
        disablePadding: false,
        label: 'Hold By',
        isShorted: false,
    },
    {
        id: 'Policy#		',
        numeric: true,
        disablePadding: false,
        label: 'Policy',
        isShorted: false,
    },
    {
        id: 'PriAuth	Referral		',
        numeric: true,
        disablePadding: false,
        label: 'PriAuth Referral',
        isShorted: false,
    },
    {
        id: 'User	',
        numeric: true,
        disablePadding: false,
        label: 'User',
        isShorted: false,
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]

// history in super bill
export const historySuperBillHeadCells = [
    {
        id: '#',
        numeric: true,
        disablePadding: true,
        label: 'Batch',
        isShorted: true,
    },
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: 'Invoice',
        isShorted: false,
    },
    {
        id: 'Billing Provider Location',
        numeric: true,
        disablePadding: false,
        label: 'Billing Provider Location',
        isShorted: true,
    },
    {
        id: 'DOS From',
        numeric: true,
        disablePadding: false,
        label: 'DOS(From)',
        isShorted: true,
    },
    {
        id: '+',
        numeric: true,
        disablePadding: false,
        label: 'DOS(To)	',
        isShorted: false,
    },
    {
        id: 'Plan',
        numeric: true,
        disablePadding: false,
        label: 'Plan',
        isShorted: false,
    },
    {
        id: 'Date',
        numeric: true,
        disablePadding: false,
        label: 'Date',
        isShorted: false,
    },
    {
        id: 'Charge($)',
        numeric: true,
        disablePadding: false,
        label: 'Charge($)',
        isShorted: false,
    },
    {
        id: ' Credited ',
        numeric: true,
        disablePadding: false,
        label: 'Credited',
        isShorted: false,
    },

    {
        id: 'Balance',
        numeric: true,
        disablePadding: false,
        label: 'Balance',
        isShorted: false,
    },

    {
        id: 'Copay	',
        numeric: true,
        disablePadding: false,
        label: 'Copay',
        isShorted: false,
    },
    {
        id: 'Priority	',
        numeric: true,
        disablePadding: false,
        label: 'Priority',
        isShorted: false,
    },
    {
        id: 'Status	',
        numeric: true,
        disablePadding: false,
        label: 'Status',
        isShorted: false,
    },
    {
        id: 'Type	',
        numeric: true,
        disablePadding: false,
        label: 'Type',
        isShorted: false,
    },
    {
        id: 'Activity User	',
        numeric: true,
        disablePadding: false,
        label: 'Activity User',
        isShorted: false,
    },
    {
        id: 'Remit.Code	',
        numeric: true,
        disablePadding: false,
        label: 'Remit Code',
        isShorted: false,
    },
    {
        id: 'Notes	',
        numeric: true,
        disablePadding: false,
        label: 'Notes',
        isShorted: false,
    },
]
// history in super bill
export const PaymentViewSuperBillHeadCells = [
    {
        id: 'Practice',
        numeric: true,
        disablePadding: true,
        label: 'Practice',
        isShorted: true,
    },
    {
        id: 'Chart',
        numeric: true,
        disablePadding: false,
        label: 'Chart',
        isShorted: false,
    },
    {
        id: 'EMR Attending Provider',
        numeric: true,
        disablePadding: false,
        label: 'EMRAttending Provider',
        isShorted: true,
    },
    {
        id: 'Appt - Location',
        numeric: true,
        disablePadding: false,
        label: 'Appt Location',
        isShorted: true,
    },
    {
        id: '+',
        numeric: true,
        disablePadding: false,
        label: 'Billing Location',
        isShorted: false,
    },
    {
        id: 'Billing Provider',
        numeric: true,
        disablePadding: false,
        label: 'Billing Provider',
        isShorted: false,
    },
    {
        id: 'Referring Provider',
        numeric: true,
        disablePadding: false,
        label: 'Referring Provider',
        isShorted: false,
    },
    {
        id: 'Rendering Provider',
        numeric: true,
        disablePadding: false,
        label: 'Rendering Provider',
        isShorted: false,
    },
    {
        id: ' Supervising Provider ',
        numeric: true,
        disablePadding: false,
        label: 'Supervising Provider',
        isShorted: false,
    },
    {
        id: 'Patient First Name	',
        numeric: true,
        disablePadding: false,
        label: 'Patient First Name',
        isShorted: false,
    },

    {
        id: 'Patient Last Name',
        numeric: true,
        disablePadding: false,
        label: 'Patient Last Name',
        isShorted: false,
    },

    {
        id: 'Patient DOB	',
        numeric: true,
        disablePadding: false,
        label: 'Patient DOB',
        isShorted: false,
    },
    {
        id: 'CaseName	',
        numeric: true,
        disablePadding: false,
        label: 'Case Name',
        isShorted: false,
    },
    {
        id: 'DOS From	',
        numeric: true,
        disablePadding: false,
        label: 'DOS(From)',
        isShorted: false,
    },
    {
        id: 'Activity User	',
        numeric: true,
        disablePadding: false,
        label: 'DOS(TO)',
        isShorted: false,
    },
    {
        id: 'CPT	',
        numeric: true,
        disablePadding: false,
        label: 'CPT',
        isShorted: false,
    },
    {
        id: 'Modifier	',
        numeric: true,
        disablePadding: false,
        label: 'Modifier',
        isShorted: false,
    },
    {
        id: 'Rev Code	',
        numeric: true,
        disablePadding: false,
        label: 'Rev Code',
        isShorted: false,
    },
    {
        id: 'Units	',
        numeric: true,
        disablePadding: false,
        label: 'Units',
        isShorted: false,
    },
    {
        id: 'POS	',
        numeric: true,
        disablePadding: false,
        label: 'POS',
        isShorted: false,
    },
    {
        id: 'Admission Date 	',
        numeric: true,
        disablePadding: false,
        label: 'Admission Date ',
        isShorted: false,
    },
    {
        id: 'Discharge Date	',
        numeric: true,
        disablePadding: false,
        label: 'Discharge Date',
        isShorted: false,
    },
    {
        id: 'Allowed Amount as per Fee Schedule	',
        numeric: true,
        disablePadding: false,
        label: 'Allowed Amount As Per Fee Schedule',
        isShorted: false,
    },
    {
        id: 'TotalPaid Amount	',
        numeric: true,
        disablePadding: false,
        label: 'Total Paid Amount',
        isShorted: false,
    },
    {
        id: 'Total Adjustment Amount	',
        numeric: true,
        disablePadding: false,
        label: 'Total Adjustment Amount',
        isShorted: false,
    },
    {
        id: 'Claim	',
        numeric: true,
        disablePadding: false,
        label: 'Claim',
        isShorted: false,
    },
    {
        id: 'Insurance~Plan / Patient	',
        numeric: true,
        disablePadding: false,
        label: 'Insurance Plan/Patient',
        isShorted: false,
    },
    {
        id: 'InsurancePriority	',
        numeric: true,
        disablePadding: false,
        label: 'Insurance Priority',
        isShorted: false,
    },
    {
        id: 'FS/RA	',
        numeric: true,
        disablePadding: false,
        label: 'FS/RA',
        isShorted: false,
    },
    {
        id: 'Posted Date	',
        numeric: true,
        disablePadding: false,
        label: 'Posted Date',
        isShorted: false,
    },
    {
        id: 'Adjustment Amount	',
        numeric: true,
        disablePadding: false,
        label: 'Adjustment Amount',
        isShorted: false,
    },
    {
        id: 'Rejection Code	',
        numeric: true,
        disablePadding: false,
        label: 'Rejection Code',
        isShorted: false,
    },
    {
        id: 'Rejection Code Description	',
        numeric: true,
        disablePadding: false,
        label: 'Rejection Code Description',
        isShorted: false,
    },
    {
        id: 'Reversal Payment	',
        numeric: true,
        disablePadding: false,
        label: 'Reversal Payment',
        isShorted: false,
    },
    {
        id: 'Reversal Adjustment	',
        numeric: true,
        disablePadding: false,
        label: 'Reversal Adjustment',
        isShorted: false,
    },
    {
        id: 'Remaining Balance	',
        numeric: true,
        disablePadding: false,
        label: 'Remainin Balance',
        isShorted: false,
    },
    {
        id: 'Insurance ID	',
        numeric: true,
        disablePadding: false,
        label: 'Insurance ID',
        isShorted: false,
    },
    {
        id: 'User	',
        numeric: true,
        disablePadding: false,
        label: 'User',
        isShorted: false,
    },
    {
        id: 'Action	',
        numeric: true,
        disablePadding: false,
        label: 'Action',
        isShorted: false,
    },
]

// Charges
export const EpiphanyChargesHeader = [
    {
        id: '',
        numeric: true,
        disablePadding: true,
        label: 'S.No',
        isShorted: true,
    },
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: 'First Name',
        isShorted: false,
    },
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: 'Last Name   ',
        isShorted: false,
    },
    {
        id: 'Reference',
        numeric: true,
        disablePadding: false,
        label: 'Patient Id',
        isShorted: false,
    },
    {
        id: 'Reference Date',
        numeric: true,
        disablePadding: false,
        label: 'DOS',
        isShorted: false,
    },
    {
        id: 'Received Date',
        numeric: true,
        disablePadding: false,
        label: 'Provider',
        isShorted: false,
    },
    {
        id: '# Claims',
        numeric: true,
        disablePadding: false,
        label: 'Primary Insurance',
        isShorted: false,
    },
    {
        id: 'Identified Claims',
        numeric: true,
        disablePadding: false,
        label: 'Secondary Insurance',
        isShorted: false,
    },
    {
        id: 'Unidentified Claims',
        numeric: true,
        disablePadding: false,
        label: 'Procedure1',
        isShorted: false,
    },
    {
        id: 'Excluded Claims',
        numeric: true,
        disablePadding: false,
        label: 'Procedure2',
        isShorted: false,
    },
    {
        id: 'Charge Amt. ($)',
        numeric: true,
        disablePadding: false,
        label: 'Claim Status',
        isShorted: false,
    },
    {
        id: 'Payment Amt. ($)',
        numeric: true,
        disablePadding: false,
        label: `Date of Submission`,
        isShorted: false,
    },
]
// insurance report
export const InsuranceLogReportHeader = [
    {
        id: '',
        numeric: true,
        disablePadding: true,
        label: 'S.No',
        isShorted: true,
    },
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: 'First Name',
        isShorted: false,
    },
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: 'Last Name   ',
        isShorted: false,
    },
    {
        id: 'Reference',
        numeric: true,
        disablePadding: false,
        label: 'Patient Id',
        isShorted: false,
    },
    {
        id: 'Reference Date',
        numeric: true,
        disablePadding: false,
        label: 'DOS',
        isShorted: false,
    },
    {
        id: 'Reference Date',
        numeric: true,
        disablePadding: false,
        label: 'UNIQUE ID',
        isShorted: false,
    },

    {
        id: 'Received Date',
        numeric: true,
        disablePadding: false,
        label: 'Provider',
        isShorted: false,
    },
    {
        id: '# Claims',
        numeric: true,
        disablePadding: false,
        label: 'Primary Insurance',
        isShorted: false,
    },
    {
        id: 'Identified Claims',
        numeric: true,
        disablePadding: false,
        label: 'Secondary Insurance',
        isShorted: false,
    },
    {
        id: 'Unidentified Claims',
        numeric: true,
        disablePadding: false,
        label: 'Procedure1',
        isShorted: false,
    },
    {
        id: 'Excluded Claims',
        numeric: true,
        disablePadding: false,
        label: 'Procedure2',
        isShorted: false,
    },
    {
        id: 'Excluded Claims',
        numeric: true,
        disablePadding: false,
        label: 'Charge Amt',
        isShorted: false,
    },
    {
        id: 'Excluded Claims',
        numeric: true,
        disablePadding: false,
        label: 'InsurancePaid',
        isShorted: false,
    },
    {
        id: 'Excluded Claims',
        numeric: true,
        disablePadding: false,
        label: 'InsuranceAllowedAmt',
        isShorted: false,
    },

    {
        id: 'Excluded Claims',
        numeric: true,
        disablePadding: false,
        label: ' Adjustment',
        isShorted: false,
    },
]

// DailyPaymentReportHearder
export const DailyPaymentReportHearder = [
    {
        id: '',
        numeric: true,
        disablePadding: true,
        label: 'S.No',
        isShorted: true,
    },
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: 'First Name',
        isShorted: false,
    },
    {
        id: '',
        numeric: true,
        disablePadding: false,
        label: 'Last Name   ',
        isShorted: false,
    },
    {
        id: 'Reference',
        numeric: true,
        disablePadding: false,
        label: 'Patient Id',
        isShorted: false,
    },
    {
        id: 'Reference Date',
        numeric: true,
        disablePadding: false,
        label: 'DOB',
        isShorted: false,
    },
    {
        id: 'Reference Date',
        numeric: true,
        disablePadding: false,
        label: 'DOS',
        isShorted: false,
    },
    {
        id: 'Received Date',
        numeric: true,
        disablePadding: false,
        label: 'Provider',
        isShorted: false,
    },
    {
        id: '# Claims',
        numeric: true,
        disablePadding: false,
        label: 'Self~Pay~Copay',
        isShorted: false,
    },
    {
        id: 'Identified Claims',
        numeric: true,
        disablePadding: false,
        label: 'Patient Due',
        isShorted: false,
    },
    {
        id: 'Unidentified Claims',
        numeric: true,
        disablePadding: false,
        label: 'Amount Paid',
        isShorted: false,
    },
    {
        id: 'Excluded Claims',
        numeric: true,
        disablePadding: false,
        label: 'Payment Mode',
        isShorted: false,
    },
    {
        id: 'Excluded Claims',
        numeric: true,
        disablePadding: false,
        label: 'Card Processed',
        isShorted: false,
    },
    {
        id: 'Excluded Claims',
        numeric: true,
        disablePadding: false,
        label: 'Payment(Last 4 digits of Card)',
        isShorted: false,
    },

    {
        id: 'Excluded Claims',
        numeric: true,
        disablePadding: false,
        label: 'Payment Date',
        isShorted: false,
    },
    {
        id: 'Excluded Claims',
        numeric: true,
        disablePadding: false,
        label: 'Payment Post Date',
        isShorted: false,
    },

    {
        id: 'Excluded Claims',
        numeric: true,
        disablePadding: false,
        label: 'Payment Sent On',
        isShorted: false,
    },

    {
        id: 'Excluded Claims',
        numeric: true,
        disablePadding: false,
        label: 'Balance',
        isShorted: false,
    },
    {
        id: 'Excluded Claims',
        numeric: true,
        disablePadding: false,
        label: 'Payment Applied / Not Applied',
        isShorted: false,
    },
]

export const remain_bal_code_Option = [
    {
        name: 'BTOI ',
        id: 'BTOI',
    },
    {
        name: 'BTP',
        id: 'BTP',
    },
]

// Time Zonbe List
export const timeZonelist = [
    {
        value: 'Dateline Standard Time',
        abbr: 'DST',
        offset: -12,
        isdst: false,
        text: '(UTC-12:00) International Date Line West',
        timezone: 'Pacific/Wallis',
    },
    {
        value: 'UTC-11',
        abbr: 'U',
        offset: -11,
        isdst: false,
        text: '(UTC-11:00) Coordinated Universal Time-11',
        timezone: 'Pacific/Pago_Pago',
    },
    {
        value: 'Hawaiian Standard Time',
        abbr: 'HST',
        offset: -10,
        isdst: false,
        text: '(UTC-10:00) Hawaii',
        timezone: 'US/Hawaii',
    },
    {
        value: 'Alaskan Standard Time',
        abbr: 'AKDT',
        offset: -9,
        isdst: true,
        text: '(UTC-09:00) Alaska',
        timezone: 'US/Alaska',
    },
    {
        value: 'Pacific Standard Time (Mexico)',
        abbr: 'PDT',
        offset: -8,
        isdst: true,
        text: '(UTC-08:00) Baja California',
        timezone: 'America/Pacific',
    },
    {
        value: 'Pacific Standard Time',
        abbr: 'PDT',
        offset: -8,
        isdst: true,
        text: '(UTC-08:00) Baja California',
        timezone: 'America/Los_Angeles',
    },

    {
        value: 'Pacific Standard Time',
        abbr: 'PDT',
        offset: -8,
        isdst: true,
        text: '(UTC-08:00) Pacific Time (US & Canada)',
        timezone: 'America/Pacific',
    },
    {
        value: 'US Mountain Standard Time',
        abbr: 'UMST',
        offset: -7,
        isdst: false,
        text: '(UTC-07:00) Arizona',
        timezone: 'America/Mountain',
    },
    {
        value: 'Mountain Standard Time (Mexico)',
        abbr: 'MDT',
        offset: -7,
        isdst: true,
        text: '(UTC-07:00) Chihuahua, La Paz, Mazatlan',
        timezone: 'America/Chihuahua',
    },
    {
        value: 'Mountain Standard Time',
        abbr: 'MDT',
        offset: -7,
        isdst: true,
        text: '(UTC-07:00) Mountain Time (US & Canada)',
        timezone: 'US/Mountain',
    },
    {
        value: 'Central America Standard Time',
        abbr: 'CAST',
        offset: -6,
        isdst: false,
        text: '(UTC-06:00) Central America',
        timezone: 'America/Managua',
    },
    {
        value: 'Central Standard Time',
        abbr: 'CDT',
        offset: -6,
        isdst: true,
        text: '(UTC-06:00) Central Time (US & Canada)',
        timezone: 'US/Central',
    },
    {
        value: 'Central Standard Time (Mexico)',
        abbr: 'CDT',
        offset: -6,
        isdst: true,
        text: '(UTC-06:00) Guadalajara, Mexico City, Monterrey',
        timezone: 'America/Mexico_City',
    },
    {
        value: 'Canada Central Standard Time',
        abbr: 'CCST',
        offset: -6,
        isdst: false,
        text: '(UTC-06:00) Saskatchewan',
        timezone: 'Canada/Saskatchewan',
    },
    {
        value: 'SA Pacific Standard Time',
        abbr: 'SPST',
        offset: -5,
        isdst: false,
        text: '(UTC-05:00) Bogota, Lima, Quito',
        timezone: 'America/Lima',
    },
    {
        value: 'Eastern Standard Time',
        abbr: 'EDT',
        offset: -5,
        isdst: true,
        text: '(UTC-05:00) Eastern Time (US & Canada)',
        timezone: 'US/Eastern',
    },
    {
        value: 'US Eastern Standard Time',
        abbr: 'UEDT',
        offset: -5,
        isdst: true,
        text: '(UTC-05:00) Indiana (East)',
        timezone: 'US/East-Indiana',
    },
    {
        value: 'Venezuela Standard Time',
        abbr: 'VST',
        offset: -4.5,
        isdst: false,
        text: '(UTC-04:30) Caracas',
        timezone: 'America/Caracas',
    },
    {
        value: 'Paraguay Standard Time',
        abbr: 'PST',
        offset: -4,
        isdst: false,
        text: '(UTC-04:00) Asuncion',
        timezone: 'America/Santiago',
    },
    {
        value: 'Atlantic Standard Time',
        abbr: 'ADT',
        offset: -4,
        isdst: true,
        text: '(UTC-04:00) Atlantic Time (Canada)',
        timezone: 'Canada/Atlantic',
    },
    {
        value: 'Central Brazilian Standard Time',
        abbr: 'CBST',
        offset: -4,
        isdst: false,
        text: '(UTC-04:00) Cuiaba',
        timezone: 'America/Sao_Paulo',
    },
    {
        value: 'SA Western Standard Time',
        abbr: 'SWST',
        offset: -4,
        isdst: false,
        text: '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan',
        timezone: 'America/La_Paz',
    },
    {
        value: 'Pacific SA Standard Time',
        abbr: 'PSST',
        offset: -4,
        isdst: false,
        text: '(UTC-04:00) Santiago',
        timezone: 'America/Santiago',
    },
    {
        value: 'Newfoundland Standard Time',
        abbr: 'NDT',
        offset: -3.5,
        isdst: true,
        text: '(UTC-03:30) Newfoundland',
        timezone: 'Canada/Newfoundland',
    },
    {
        value: 'E. South America Standard Time',
        abbr: 'ESAST',
        offset: -3,
        isdst: false,
        text: '(UTC-03:00) Brasilia',
        timezone: 'America/Sao_Paulo',
    },
    {
        value: 'Argentina Standard Time',
        abbr: 'AST',
        offset: -3,
        isdst: false,
        text: '(UTC-03:00) Buenos Aires',
        timezone: 'America/Argentina/Buenos_Aires',
    },
    {
        value: 'SA Eastern Standard Time',
        abbr: 'SEST',
        offset: -3,
        isdst: false,
        text: '(UTC-03:00) Cayenne, Fortaleza',
        timezone: 'America/Cayenne',
    },
    {
        value: 'Greenland Standard Time',
        abbr: 'GDT',
        offset: -3,
        isdst: true,
        text: '(UTC-03:00) Greenland',
        timezone: 'America/Godthab',
    },
    {
        value: 'Montevideo Standard Time',
        abbr: 'MST',
        offset: -3,
        isdst: false,
        text: '(UTC-03:00) Montevideo',
        timezone: 'America/Montevideo',
    },
    {
        value: 'Bahia Standard Time',
        abbr: 'BST',
        offset: -3,
        isdst: false,
        text: '(UTC-03:00) Salvador',
        timezone: 'America/Montevideo',
    },
    {
        value: 'UTC-02',
        abbr: 'U',
        offset: -2,
        isdst: false,
        text: '(UTC-02:00) Coordinated Universal Time-02',
        timezone: 'America/Godthab',
    },
    {
        value: 'Mid-Atlantic Standard Time',
        abbr: 'MDT',
        offset: -2,
        isdst: true,
        text: '(UTC-02:00) Mid-Atlantic - Old',
        timezone: 'America/Noronha',
    },
    {
        value: 'Azores Standard Time',
        abbr: 'ADT',
        offset: -1,
        isdst: true,
        text: '(UTC-01:00) Azores',
        timezone: 'Atlantic/Azores',
    },
    {
        value: 'Cape Verde Standard Time',
        abbr: 'CVST',
        offset: -1,
        isdst: false,
        text: '(UTC-01:00) Cape Verde Is.',
        timezone: 'Atlantic/Cape_Verde',
    },
    {
        value: 'Morocco Standard Time',
        abbr: 'MDT',
        offset: 0,
        isdst: true,
        text: '(UTC) Casablanca',
        timezone: 'Africa/Casablanca',
    },
    {
        value: 'UTC',
        abbr: 'CUT',
        offset: 0,
        isdst: false,
        text: '(UTC) Coordinated Universal Time',
        timezone: 'Etc/Greenwich',
    },
    {
        value: 'GMT Standard Time',
        abbr: 'GDT',
        offset: 0,
        isdst: true,
        text: '(UTC) Dublin, Edinburgh, Lisbon, London',
        timezone: 'Europe/London',
    },
    {
        value: 'Greenwich Standard Time',
        abbr: 'GST',
        offset: 0,
        isdst: false,
        text: '(UTC) Monrovia, Reykjavik',
        timezone: 'Africa/Monrovia',
    },
    {
        value: 'W. Europe Standard Time',
        abbr: 'WEDT',
        offset: 1,
        isdst: true,
        text: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
        timezone: 'Europe/Amsterdam',
    },
    {
        value: 'Central Europe Standard Time',
        abbr: 'CEDT',
        offset: 1,
        isdst: true,
        text: '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
        timezone: 'Europe/Budapest',
    },
    {
        value: 'Romance Standard Time',
        abbr: 'RDT',
        offset: 1,
        isdst: true,
        text: '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris',
        timezone: 'Europe/Paris',
    },
    {
        value: 'Central European Standard Time',
        abbr: 'CEDT',
        offset: 1,
        isdst: true,
        text: '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb',
        timezone: 'Europe/Warsaw',
    },
    {
        value: 'W. Central Africa Standard Time',
        abbr: 'WCAST',
        offset: 1,
        isdst: false,
        text: '(UTC+01:00) West Central Africa',
        timezone: 'Africa/Lagos',
    },
    {
        value: 'Namibia Standard Time',
        abbr: 'NST',
        offset: 1,
        isdst: false,
        text: '(UTC+01:00) Windhoek',
        timezone: 'Africa/Windhoek',
    },
    {
        value: 'GTB Standard Time',
        abbr: 'GDT',
        offset: 2,
        isdst: true,
        text: '(UTC+02:00) Athens, Bucharest',
        timezone: 'Europe/Athens',
    },
    {
        value: 'Middle East Standard Time',
        abbr: 'MEDT',
        offset: 2,
        isdst: true,
        text: '(UTC+02:00) Beirut',
        timezone: 'Asia/Beirut',
    },
    {
        value: 'Egypt Standard Time',
        abbr: 'EST',
        offset: 2,
        isdst: false,
        text: '(UTC+02:00) Cairo',
        timezone: 'Africa/Cairo',
    },
    {
        value: 'Syria Standard Time',
        abbr: 'SDT',
        offset: 2,
        isdst: true,
        text: '(UTC+02:00) Damascus',
        timezone: 'Asia/Damascus',
    },
    {
        value: 'E. Europe Standard Time',
        abbr: 'EEDT',
        offset: 2,
        isdst: true,
        text: '(UTC+02:00) E. Europe',
        timezone: 'Europe/London',
    },
    {
        value: 'South Africa Standard Time',
        abbr: 'SAST',
        offset: 2,
        isdst: false,
        text: '(UTC+02:00) Harare, Pretoria',
        timezone: 'Africa/Harare',
    },
    {
        value: 'FLE Standard Time',
        abbr: 'FDT',
        offset: 2,
        isdst: true,
        text: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
        timezone: 'Europe/Helsinki',
    },
    {
        value: 'Turkey Standard Time',
        abbr: 'TDT',
        offset: 2,
        isdst: true,
        text: '(UTC+02:00) Istanbul',
        timezone: 'Europe/Istanbul',
    },
    {
        value: 'Israel Standard Time',
        abbr: 'JDT',
        offset: 2,
        isdst: true,
        text: '(UTC+02:00) Jerusalem',
        timezone: 'Asia/Jerusalem',
    },
    {
        value: 'Libya Standard Time',
        abbr: 'LST',
        offset: 2,
        isdst: false,
        text: '(UTC+02:00) Tripoli',
        timezone: 'Africa/Tripoli',
    },
    {
        value: ' Standard Time',
        abbr: 'JST',
        offset: 3,
        isdst: false,
        text: '(UTC+03:00) Amman',
        timezone: 'Asia/Amman',
    },
    {
        value: 'Arabic Standard Time',
        abbr: 'AST',
        offset: 3,
        isdst: false,
        text: '(UTC+03:00) Baghdad',
        timezone: 'Asia/Baghdad',
    },
    {
        value: 'Kaliningrad Standard Time',
        abbr: 'KST',
        offset: 3,
        isdst: false,
        text: '(UTC+03:00) Kaliningrad, Minsk',
        timezone: 'Europe/Minsk',
    },
    {
        value: 'Arab Standard Time',
        abbr: 'AST',
        offset: 3,
        isdst: false,
        text: '(UTC+03:00) Kuwait, Riyadh',
        timezone: 'Asia/Kuwait',
    },
    {
        value: 'E. Africa Standard Time',
        abbr: 'EAST',
        offset: 3,
        isdst: false,
        text: '(UTC+03:00) Nairobi',
        timezone: 'Africa/Nairobi',
    },
    {
        value: 'Iran Standard Time',
        abbr: 'IDT',
        offset: 3.5,
        isdst: true,
        text: '(UTC+03:30) Tehran',
        timezone: 'Asia/Tehran',
    },
    {
        value: 'Arabian Standard Time',
        abbr: 'AST',
        offset: 4,
        isdst: false,
        text: '(UTC+04:00) Abu Dhabi, Muscat',
        timezone: 'Asia/Muscat',
    },
    {
        value: 'Azerbaijan Standard Time',
        abbr: 'ADT',
        offset: 4,
        isdst: true,
        text: '(UTC+04:00) Baku',
        timezone: 'Asia/Baku',
    },
    {
        value: 'Russian Standard Time',
        abbr: 'RST',
        offset: 4,
        isdst: false,
        text: '(UTC+04:00) Moscow, St. Petersburg, Volgograd',
        timezone: 'Europe/Moscow',
    },
    {
        value: 'Mauritius Standard Time',
        abbr: 'MST',
        offset: 4,
        isdst: false,
        text: '(UTC+04:00) Port Louis',
        timezone: 'Indian/Mauritius',
    },
    {
        value: 'Georgian Standard Time',
        abbr: 'GST',
        offset: 4,
        isdst: false,
        text: '(UTC+04:00) Tbilisi',
        timezone: 'Asia/Tbilisi',
    },
    {
        value: 'Caucasus Standard Time',
        abbr: 'CST',
        offset: 4,
        isdst: false,
        text: '(UTC+04:00) Yerevan',
        timezone: 'Asia/Yerevan',
    },
    {
        value: 'Afghanistan Standard Time',
        abbr: 'AST',
        offset: 4.5,
        isdst: false,
        text: '(UTC+04:30) Kabul',
        timezone: 'Asia/Kabul',
    },
    {
        value: 'West Asia Standard Time',
        abbr: 'WAST',
        offset: 5,
        isdst: false,
        text: '(UTC+05:00) Ashgabat, Tashkent',
        timezone: 'Asia/Tashkent',
    },
    {
        value: 'Pakistan Standard Time',
        abbr: 'PST',
        offset: 5,
        isdst: false,
        text: '(UTC+05:00) Islamabad, Karachi',
        timezone: 'Asia/Karachi',
    },
    {
        value: 'India Standard Time',
        abbr: 'IST',
        offset: 5.5,
        isdst: false,
        text: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi',
        timezone: 'Asia/Kolkata',
    },
    {
        value: 'Sri Lanka Standard Time',
        abbr: 'SLST',
        offset: 5.5,
        isdst: false,
        text: '(UTC+05:30) Sri Jayawardenepura',
        timezone: 'Asia/Calcutta',
    },
    {
        value: 'Nepal Standard Time',
        abbr: 'NST',
        offset: 5.75,
        isdst: false,
        text: '(UTC+05:45) Kathmandu',
        timezone: 'Asia/Katmandu',
    },
    {
        value: 'Central Asia Standard Time',
        abbr: 'CAST',
        offset: 6,
        isdst: false,
        text: '(UTC+06:00) Astana',
        timezone: 'Asia/Dhaka',
    },
    {
        value: 'Bangladesh Standard Time',
        abbr: 'BST',
        offset: 6,
        isdst: false,
        text: '(UTC+06:00) Dhaka',
        timezone: 'Asia/Dhaka',
    },
    {
        value: 'Ekaterinburg Standard Time',
        abbr: 'EST',
        offset: 6,
        isdst: false,
        text: '(UTC+06:00) Ekaterinburg',
        timezone: 'Asia/Yekaterinburg',
    },
    {
        value: 'Myanmar Standard Time',
        abbr: 'MST',
        offset: 6.5,
        isdst: false,
        text: '(UTC+06:30) Yangon (Rangoon)',
        timezone: 'Asia/Rangoon',
    },
    {
        value: 'SE Asia Standard Time',
        abbr: 'SAST',
        offset: 7,
        isdst: false,
        text: '(UTC+07:00) Bangkok, Hanoi, Jakarta',
        timezone: 'Asia/Bangkok',
    },
    {
        value: 'N. Central Asia Standard Time',
        abbr: 'NCAST',
        offset: 7,
        isdst: false,
        text: '(UTC+07:00) Novosibirsk',
        timezone: 'Asia/Novosibirsk',
    },
    {
        value: 'China Standard Time',
        abbr: 'CST',
        offset: 8,
        isdst: false,
        text: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
        timezone: 'Asia/Hong_Kong',
    },
    {
        value: 'North Asia Standard Time',
        abbr: 'NAST',
        offset: 8,
        isdst: false,
        text: '(UTC+08:00) Krasnoyarsk',
        timezone: 'Asia/Krasnoyarsk',
    },
    {
        value: 'Singapore Standard Time',
        abbr: 'MPST',
        offset: 8,
        isdst: false,
        text: '(UTC+08:00) Kuala Lumpur, Singapore',
        timezone: 'Asia/Kuala_Lumpur',
    },
    {
        value: 'W. Australia Standard Time',
        abbr: 'WAST',
        offset: 8,
        isdst: false,
        text: '(UTC+08:00) Perth',
        timezone: 'Australia/Perth',
    },
    {
        value: 'Taipei Standard Time',
        abbr: 'TST',
        offset: 8,
        isdst: false,
        text: '(UTC+08:00) Taipei',
        timezone: 'Asia/Taipei',
    },
    {
        value: 'Ulaanbaatar Standard Time',
        abbr: 'UST',
        offset: 8,
        isdst: false,
        text: '(UTC+08:00) Ulaanbaatar',
        timezone: 'Asia/Ulaanbaatar',
    },
    {
        value: 'North Asia East Standard Time',
        abbr: 'NAEST',
        offset: 9,
        isdst: false,
        text: '(UTC+09:00) Irkutsk',
        timezone: 'Asia/Irkutsk',
    },
    {
        value: 'Tokyo Standard Time',
        abbr: 'TST',
        offset: 9,
        isdst: false,
        text: '(UTC+09:00) Osaka, Sapporo, Tokyo',
        timezone: 'Asia/Tokyo',
    },
    {
        value: 'Korea Standard Time',
        abbr: 'KST',
        offset: 9,
        isdst: false,
        text: '(UTC+09:00) Seoul',
        timezone: 'Asia/Seoul',
    },
    {
        value: 'Cen. Australia Standard Time',
        abbr: 'CAST',
        offset: 9.5,
        isdst: false,
        text: '(UTC+09:30) Adelaide',
        timezone: 'Australia/Adelaide',
    },
    {
        value: 'AUS Central Standard Time',
        abbr: 'ACST',
        offset: 9.5,
        isdst: false,
        text: '(UTC+09:30) Darwin',
        timezone: 'Australia/Darwin',
    },
    {
        value: 'E. Australia Standard Time',
        abbr: 'EAST',
        offset: 10,
        isdst: false,
        text: '(UTC+10:00) Brisbane',
        timezone: 'Australia/Brisbane',
    },
    {
        value: 'AUS Eastern Standard Time',
        abbr: 'AEST',
        offset: 10,
        isdst: false,
        text: '(UTC+10:00) Canberra, Melbourne, Sydney',
        timezone: 'Australia/Melbourne',
    },
    {
        value: 'West Pacific Standard Time',
        abbr: 'WPST',
        offset: 10,
        isdst: false,
        text: '(UTC+10:00) Guam, Port Moresby',
        timezone: 'Pacific/Port_Moresby',
    },
    {
        value: 'Tasmania Standard Time',
        abbr: 'TST',
        offset: 10,
        isdst: false,
        text: '(UTC+10:00) Hobart',
        timezone: 'Australia/Hobart',
    },
    {
        value: 'Yakutsk Standard Time',
        abbr: 'YST',
        offset: 10,
        isdst: false,
        text: '(UTC+10:00) Yakutsk',
        timezone: 'Asia/Yakutsk',
    },
    {
        value: 'Central Pacific Standard Time',
        abbr: 'CPST',
        offset: 11,
        isdst: false,
        text: '(UTC+11:00) Solomon Is., New Caledonia',
        timezone: 'Pacific/Guadalcanal',
    },
    {
        value: 'Vladivostok Standard Time',
        abbr: 'VST',
        offset: 11,
        isdst: false,
        text: '(UTC+11:00) Vladivostok',
        timezone: 'Asia/Vladivostok',
    },
    {
        value: 'New Zealand Standard Time',
        abbr: 'NZST',
        offset: 12,
        isdst: false,
        text: '(UTC+12:00) Auckland, Wellington',
        timezone: 'Pacific/Auckland',
    },
    {
        value: 'UTC+12',
        abbr: 'U',
        offset: 12,
        isdst: false,
        text: '(UTC+12:00) Coordinated Universal Time+12',
        timezone: 'Pacific/Kwajalein',
    },
    {
        value: 'Fiji Standard Time',
        abbr: 'FST',
        offset: 12,
        isdst: false,
        text: '(UTC+12:00) Fiji',
        timezone: 'Pacific/Fiji',
    },
    {
        value: 'Magadan Standard Time',
        abbr: 'MST',
        offset: 12,
        isdst: false,
        text: '(UTC+12:00) Magadan',
        timezone: 'Asia/Magadan',
    },
    {
        value: 'Kamchatka Standard Time',
        abbr: 'KDT',
        offset: 13,
        isdst: true,
        text: '(UTC+12:00) Petropavlovsk-Kamchatsky - Old',
        timezone: 'Asia/Kamchatka',
    },
    {
        value: 'Tonga Standard Time',
        abbr: 'TST',
        offset: 13,
        isdst: false,
        text: "(UTC+13:00) Nuku'alofa",
        timezone: 'Pacific/Tongatapu',
    },
    {
        value: 'Samoa Standard Time',
        abbr: 'SST',
        offset: 13,
        isdst: false,
        text: '(UTC+13:00) Samoa',
        timezone: 'Pacific/Samoa',
    },
]

// Adjustment code
export let AdjustmentCode = [
    {
        code: '45',
        description:
            'Charge exceeds fee schedule/maximum allowable or contracted/legislated fee arrangement. Note: This adjustment amount cannot equal the total service or claim charge amount; and must not duplicate provider adjustment amounts (payments and contractual reductions) that have resulted from prior payer(s) adjudication. (Use only with Group Codes PR or CO depending upon liability)',
    },
    {
        code: 'CO-97',
        description: 'The benefit for this service is included in the p',
    },
    {
        code: '16',
        description:
            '"Claim/service lacks information or has submission/billing error(s) which is needed for adjudication. Do not use this code for claims attachment(s)/other documentation. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.) Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: 'NON COVERED',
        description: 'Non covered services',
    },
    {
        code: '253',
        description: 'Sequestration - reduction in federal payment',
    },
    {
        code: '96',
        description:
            '"Non-covered charge(s). At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.) Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '246',
        description: 'This non-payable code is for required reporting only.',
    },
    {
        code: '97',
        description:
            '"The benefit for this service is included in the payment/allowance for another service/procedure that has already been adjudicated. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: 'MEDICAID BALANCE',
        description: 'MEDICAID BALANCE ADJUSTED',
    },
    {
        code: '256',
        description: 'Service not payable per managed care contract.',
    },
    {
        code: 'A1',
        description:
            '"Claim/Service denied. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)"',
    },
    {
        code: 'B13',
        description: 'Previously paid. Payment for this claim/service may have been provided in a previous payment.',
    },
    {
        code: '237',
        description:
            '"Legislated/Regulatory Penalty. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)"',
    },
    {
        code: '18',
        description: "Exact duplicate claim/service (Use only with Group Code OA except where state workers' compensation regulations requires CO)",
    },
    {
        code: '22',
        description: 'This care may be covered by another payer per coordination of benefits.',
    },
    {
        code: '236',
        description:
            'This procedure or procedure/modifier combination is not compatible with another procedure or procedure/modifier combination provided on the same day according to the National Correct Coding Initiative or workers compensation state regulations/ fee schedule requirements.',
    },
    {
        code: 'B7',
        description:
            '"This provider was not certified/eligible to be paid for this procedure/service on this date of service. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: 'B16',
        description: "'New Patient' qualifications were not met.",
    },
    {
        code: '151',
        description: 'Payment adjusted because the payer deems the information submitted does not support this many/frequency of services.',
    },
    {
        code: '204',
        description: 'This service/equipment/drug is not covered under the patient?s current benefit plan',
    },
    {
        code: '31',
        description: 'Patient cannot be identified as our insured.',
    },
    {
        code: '4',
        description:
            '"The procedure code is inconsistent with the modifier used or a required modifier is missing. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '185',
        description:
            '"The rendering provider is not eligible to perform the service billed. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '109',
        description: 'Claim/service not covered by this payer/contractor. You must send the claim/service to the correct payer/contractor.',
    },
    {
        code: '50',
        description:
            '"These are non-covered services because this is not deemed a \'medical necessity\' by the payer. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '231',
        description:
            '"Mutually exclusive procedures cannot be done in the same day/setting. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '21',
        description: 'This injury/illness is the liability of the no-fault carrier.',
    },
    {
        code: '272',
        description: 'Coverage/program guidelines were not met.',
    },
    {
        code: '29',
        description: 'The time limit for filing has expired.',
    },
    {
        code: '187',
        description: '"Consumer Spending Account payments (includes but is not limited to Flexible Spending Account, Health Savings Account, Health Reimbursement Account, etc.)"',
    },
    {
        code: '197',
        description: 'Precertification/authorization/notification absent.',
    },
    {
        code: 'OON',
        description: 'Out of Network',
    },
    {
        code: '24',
        description: 'Charges are covered under a capitation agreement/managed care plan.',
    },
    {
        code: '226',
        description:
            '"Information requested from the Billing/Rendering Provider was not provided or not provided timely or was insufficient/incomplete. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)"',
    },
    {
        code: '252',
        description:
            '"An attachment/other documentation is required to adjudicate this claim/service. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT)."',
    },
    {
        code: '216',
        description: 'Based on the findings of a review organization',
    },
    {
        code: 'B23',
        description: '"Procedure billed is not authorized per your Clinical Laboratory Improvement Amendment (CLIA) proficiency test."',
    },
    {
        code: 'P12',
        description:
            '"Workers\' compensation jurisdictional fee schedule adjustment. Note: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Class of Contract Code Identification Segment (Loop 2100 Other Claim Related Information REF). If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Workers\' Compensation only."',
    },
    {
        code: 'P24',
        description:
            '"Payment adjusted based on Preferred Provider Organization (PPO). Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Class of Contract Code Identification Segment (Loop 2100 Other Claim Related Informat"',
    },
    {
        code: '234',
        description:
            '"This procedure is not paid separately. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)"',
    },
    {
        code: '144',
        description: '"Incentive adjustment, e.g. preferred product/service."',
    },
    {
        code: '222',
        description:
            '"Exceeds the contracted maximum number of hours/days/units by this provider for this period. This is not patient specific. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '198',
        description: 'Precertification/authorization exceeded.',
    },
    {
        code: '94',
        description: 'Processed in Excess of charges.',
    },
    {
        code: '112',
        description: 'Service not furnished directly to the patient and/or not documented.',
    },
    {
        code: '119',
        description: 'Benefit maximum for this time period or occurrence has been reached.',
    },
    {
        code: '11',
        description:
            '"The diagnosis is inconsistent with the procedure. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '59',
        description:
            '"Processed based on multiple or concurrent procedure rules. (For example multiple surgery or diagnostic imaging, concurrent anesthesia.) Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: 'B11',
        description: '"The claim/service has been transferred to the proper payer/processor for processing. Claim/service not covered by this payer/processor."',
    },
    {
        code: '95',
        description: 'Plan procedures not followed.',
    },
    {
        code: '131',
        description: 'Claim specific negotiated discount.',
    },
    {
        code: 'B15',
        description:
            '"This service/procedure requires that a qualifying service/procedure be received and covered. The qualifying other service/procedure has not been received/adjudicated. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '273',
        description: 'Coverage/program guidelines were exceeded.',
    },
    {
        code: '147',
        description: 'Provider contracted/negotiated rate expired or not on file.',
    },
    {
        code: '208',
        description: 'National Provider Identifier - Not matched.',
    },
    {
        code: '91',
        description: 'Dispensing fee adjustment.',
    },
    {
        code: '286',
        description: 'Appeal time limits not met',
    },
    {
        code: '227',
        description:
            '"Information requested from the patient/insured/responsible party was not provided or was insufficient/incomplete. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)"',
    },
    {
        code: '5',
        description:
            '"The procedure code/bill type is inconsistent with the place of service. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '242',
        description: 'Services not provided by network/primary care providers.',
    },
    {
        code: '251',
        description:
            '"The attachment/other documentation that was received was incomplete or deficient. The necessary information is still needed to process the claim. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT)."',
    },
    {
        code: '299',
        description: 'The billing provider is not eligible to receive payment for the service billed.',
    },
    {
        code: '13',
        description: 'The date of death precedes the date of service.',
    },
    {
        code: '9',
        description:
            '"The diagnosis is inconsistent with the patient\'s age. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '70',
        description: 'Cost outlier - Adjustment to compensate for additional costs.',
    },
    {
        code: '129',
        description:
            '"Prior processing information appears incorrect. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)"',
    },
    {
        code: '146',
        description: 'Diagnosis was invalid for the date(s) of service reported.',
    },
    {
        code: '150',
        description: 'Payer deems the information submitted does not support this level of service.',
    },
    {
        code: '193',
        description: '"Original payment decision is being maintained. Upon review, it was determined that this claim was processed properly."',
    },
    {
        code: '108',
        description:
            '"Rent/purchase guidelines were not met. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '107',
        description:
            '"The related or qualifying claim/service was not identified on this claim. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '6',
        description:
            '"The procedure/revenue code is inconsistent with the patient\'s age. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '163',
        description: 'Attachment/other documentation referenced on the claim was not received.',
    },
    {
        code: 'B9',
        description: 'Patient is enrolled in a Hospice.',
    },
    {
        code: 'B10',
        description:
            '"Allowed amount has been reduced because a component of the basic procedure/test was paid. The beneficiary is not liable for more than the charge limit for the basic procedure/test."',
    },
    {
        code: '171',
        description:
            '"Payment is denied when performed/billed by this type of provider in this type of facility. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: 'B20',
        description: 'Procedure/service was partially or fully furnished by another provider.',
    },
    {
        code: '23',
        description: 'The impact of prior payer(s) adjudication including payments and/or adjustments. (Use only with Group Code OA)',
    },
    {
        code: '143',
        description: 'Portion of payment deferred.',
    },
    {
        code: '58',
        description:
            '"Treatment was deemed by the payer to have been rendered in an inappropriate or invalid place of service. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '123',
        description: 'Payer refund due to overpayment.',
    },
    {
        code: '124',
        description: 'Payer refund amount - not our patient.',
    },
    {
        code: '125',
        description:
            '"Submission/billing error(s). At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)"',
    },
    {
        code: '4',
        description:
            '"Modifier Incorrect. The procedure code is inconsistent with the modifier used or a required modifier is missing. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '23',
        description: 'The impact of prior payer(s) adjudication including payments and/or adjustments. (Use only with Group Code OA)',
    },
    {
        code: 'PROCURT',
        description: 'Provider Courtesy',
    },
    {
        code: 'SEC BAL',
        description: 'Secondary Balance W/off',
    },
    {
        code: 'GLOBAL FFS',
        description: 'GLOBAL TO FFS OR FFS TO GLOBAL INSURANCE BAL W/OFF',
    },
    {
        code: 'GLOBALPERIOD',
        description: 'GLOBAL PERIOD OF ANOTHER SERVICE',
    },
    {
        code: '104',
        description: 'Managed care withholding.',
    },
    {
        code: '105',
        description: 'Tax withholding.',
    },
    {
        code: '106',
        description: 'Patient payment option/election not in effect.',
    },
    {
        code: '109',
        description: 'Claim/service not covered by this payer/contractor. You must send the claim/service to the correct payer/contractor.',
    },
    {
        code: '111',
        description: 'Not covered unless the provider accepts assignment.',
    },
    {
        code: '113',
        description: 'Payment denied because service/procedure was provided outside the United States or as a result of war.',
    },
    {
        code: '119',
        description: 'Benefit maximum for this time period or occurrence has been reached.',
    },
    {
        code: '120',
        description: 'Patient is covered by a managed care plan.',
    },
    {
        code: '121',
        description: 'Indemnification adjustment - compensation for outstanding member responsibility.',
    },
    {
        code: '122',
        description: 'Psychiatric reduction.',
    },
    {
        code: '127',
        description: 'Coinsurance -- Major Medical',
    },
    {
        code: '13',
        description: 'The date of death precedes the date of service.',
    },
    {
        code: '130',
        description: 'Claim submission fee.',
    },
    {
        code: '14',
        description: 'The date of birth follows the date of service.',
    },
    {
        code: '142',
        description: 'Monthly Medicaid patient liability amount.',
    },
    {
        code: '145',
        description: 'Premium payment withholding',
    },
    {
        code: '146',
        description: 'Diagnosis was invalid for the date(s) of service reported.',
    },
    {
        code: '148',
        description:
            '"Information from another provider was not provided or was insufficient/incomplete. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)"',
    },
    {
        code: '71',
        description: 'Primary Payer amount.',
    },
    {
        code: '94',
        description: 'Processed in Excess of charges.',
    },
    {
        code: 'A0',
        description: 'Patient refund amount.',
    },
    {
        code: 'A1',
        description:
            '"Claim/Service denied. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)"',
    },
    {
        code: '29',
        description: 'The time limit for filing has expired.',
    },
    {
        code: '51',
        description:
            '"These are non-covered services because this is a pre-existing condition. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '25',
        description: 'Payment denied. Your Stop loss deductible has not been met.',
    },
    {
        code: '250',
        description:
            '"The attachment/other documentation that was received was the incorrect attachment/document. The expected attachment/document is still missing. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT)."',
    },
    {
        code: '211',
        description: 'National Drug Codes (NDC) not eligible for rebate, are not covered.',
    },
    {
        code: '225',
        description: 'Penalty or Interest Payment by Payer (Only used for plan to plan encounter reporting within the 837)',
    },
    {
        code: '233',
        description: 'Services/charges related to the treatment of a hospital-acquired condition or preventable medical error.',
    },
    {
        code: '245',
        description: 'Provider performance program withhold.',
    },
    {
        code: '247',
        description: 'Deductible for Professional service rendered in an Institutional setting and billed on an Institutional claim.',
    },
    {
        code: '248',
        description: 'Coinsurance for Professional service rendered in an Institutional setting and billed on an Institutional claim.',
    },
    {
        code: '249',
        description: 'This claim has been identified as a readmission. (Use only with Group Code CO)',
    },
    {
        code: '251',
        description:
            '"The attachment/other documentation that was received was incomplete or deficient. The necessary information is still needed to process the claim. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT)."',
    },
    {
        code: '252',
        description:
            '"An attachment/other documentation is required to adjudicate this claim/service. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT)."',
    },
    {
        code: '256',
        description: 'Service not payable per managed care contract.',
    },
    {
        code: '26',
        description: 'Expenses incurred prior to coverage.',
    },
    {
        code: '101',
        description: 'Predetermination: anticipated payment upon completion of services or claim adjudication.',
    },
    {
        code: '107',
        description:
            '"The related or qualifying claim/service was not identified on this claim. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '108',
        description:
            '"Rent/purchase guidelines were not met. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '110',
        description: 'Billing date predates service date.',
    },
    {
        code: '114',
        description: 'Procedure/product not approved by the Food and Drug Administration.',
    },
    {
        code: '117',
        description: 'Transportation is only covered to the closest facility that can provide the necessary care.',
    },
    {
        code: '131',
        description: 'Claim specific negotiated discount.',
    },
    {
        code: '135',
        description: 'Interim bills cannot be processed.',
    },
    {
        code: '143',
        description: 'Portion of payment deferred.',
    },
    {
        code: '170',
        description:
            '"Payment is denied when performed/billed by this type of provider. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '171',
        description:
            '"Payment is denied when performed/billed by this type of provider in this type of facility. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '102',
        description: 'Major Medical Adjustment.',
    },
    {
        code: '18',
        description: "Exact duplicate claim/service (Use only with Group Code OA except where state workers' compensation regulations requires CO)",
    },
    {
        code: '187',
        description: '"Consumer Spending Account payments (includes but is not limited to Flexible Spending Account, Health Savings Account, Health Reimbursement Account, etc.)"',
    },
    {
        code: '96',
        description:
            '"Non-covered charge(s). At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.) Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '100',
        description: 'Payment made to patient/insured/responsible party/employer.',
    },
    {
        code: 'B15',
        description:
            '"This service/procedure requires that a qualifying service/procedure be received and covered. The qualifying other service/procedure has not been received/adjudicated. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '97',
        description:
            '"The benefit for this service is included in the payment/allowance for another service/procedure that has already been adjudicated. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '197',
        description: 'Precertification/authorization/notification absent.',
    },
    {
        code: '22',
        description: 'This care may be covered by another payer per coordination of benefits.',
    },
    {
        code: '181',
        description: 'Procedure code was invalid on the date of service.',
    },
    {
        code: '59',
        description:
            '"Processed based on multiple or concurrent procedure rules. (For example multiple surgery or diagnostic imaging, concurrent anesthesia.) Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '193',
        description: '"Original payment decision is being maintained. Upon review, it was determined that this claim was processed properly."',
    },
    {
        code: '19',
        description: "This is a work-related injury/illness and thus the liability of the Worker's Compensation Carrier.",
    },
    {
        code: '133',
        description:
            '"The disposition of this service line is pending further review. (Use only with Group Code OA). Note: Use of this code requires a reversal and correction when the service line is finalized (use only in Loop 2110 CAS segment of the 835 or Loop 2430 of the 837)."',
    },
    {
        code: '223',
        description:
            '"Adjustment code for mandated federal, state or local law/regulation that is not already covered by another code and is mandated before a new code can be created."',
    },
    {
        code: '226',
        description:
            '"Information requested from the Billing/Rendering Provider was not provided or not provided timely or was insufficient/incomplete. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)"',
    },
    {
        code: '129',
        description:
            '"Prior processing information appears incorrect. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)"',
    },
    {
        code: '215',
        description: 'Based on subrogation of a third party settlement',
    },
    {
        code: '16',
        description:
            '"Claim/service lacks information or has submission/billing error(s) which is needed for adjudication. Do not use this code for claims attachment(s)/other documentation. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.) Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '11',
        description:
            '"The diagnosis is inconsistent with the procedure. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '21',
        description: 'This injury/illness is the liability of the no-fault carrier.',
    },
    {
        code: '136',
        description: "Failure to follow prior payer's coverage rules. (Use only with Group Code OA)",
    },
    {
        code: '257',
        description:
            '"The disposition of the claim/service is undetermined during the premium payment grace period, per Health Insurance Exchange requirements. This claim/service will be reversed and corrected when the grace period ends (due to premium payment or lack of premium payment). (Use only with Group Code OA)"',
    },
    {
        code: 'B13',
        description: 'Previously paid. Payment for this claim/service may have been provided in a previous payment.',
    },
    {
        code: '209',
        description:
            '"Per regulatory or other agreement. The provider cannot collect this amount from the patient. However, this amount may be billed to subsequent payer. Refund to patient if collected. (Use only with Group code OA)"',
    },
    {
        code: '1',
        description: 'Deductible Amount',
    },
    {
        code: '2',
        description: 'Coinsurance Amount',
    },
    {
        code: '3',
        description: 'Co-payment Amount',
    },
    {
        code: '126',
        description: 'Deductible -- Major Medical',
    },
    {
        code: 'FUP VISIT',
        description: 'Follow Up Visit',
    },

    {
        code: 'SMALL BALANCE',
        category: 'Patient Responsibility',
        description: 'Small Balance Write Off',
    },
    {
        code: 'EMP FAMILY FRND',
        category: 'Patient Responsibility',
        description: 'Employee/ Family Friend',
    },
    {
        code: 'PR-100',
        category: 'Patient Responsibility',
        description: 'Payment has been made to Patient Per insurance carrier payment has been made to Patient',
    },
    {
        code: '96',
        category: 'Patient Responsibility',
        description:
            '"Non-covered charge(s). At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.) Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: 'WC',
        category: 'Patient Responsibility',
        description:
            'workers compensation information needed Please provide your workers compensation information otherwise you are responsible to pay for the services provided to you in our facility',
    },
    {
        code: '242',
        category: 'Patient Responsibility',
        description: 'Services not provided by network/primary care pro Services not provided by network/primary care providers.',
    },
    {
        code: '27',
        category: 'Patient Responsibility',
        description: 'Expenses incurred after coverage terminated. Expenses incurred after coverage terminated.',
    },
    {
        code: '227',
        category: 'Patient Responsibility',
        description:
            '"Information requested from the patient/insured/responsible party was not provided or was insufficient/incomplete. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)"',
    },
    {
        code: '50',
        category: 'Patient Responsibility',
        description:
            '"These are non-covered services because this is not deemed a \'medical necessity\' by the payer. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '31',
        category: 'Patient Responsibility',
        description: 'Patient cannot be identified as our insured. Patient cannot be identified as our insured.',
    },
    {
        code: '246',
        category: 'Patient Responsibility',
        description: 'This non-payable code is for required reporting o This non-payable code is for required reporting only.',
    },
    {
        code: '21',
        category: 'Patient Responsibility',
        description: 'This injury/illness is the liability of the no-fa This injury/illness is the liability of the no-fault carrier.',
    },
    {
        code: '55',
        category: 'Patient Responsibility',
        description:
            '"Procedure/treatment/drug is deemed experimental/investigational by the payer. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '45',
        category: 'Patient Responsibility',
        description:
            '"Charge exceeds fee schedule/maximum allowable or contracted/legislated fee arrangement. Note: This adjustment amount cannot equal the total service or claim charge amount; and must not duplicate provider adjustment amounts (payments and contractual reductions) that have resulted from prior payer(s) adjudication. (Use only with Group Codes PR or CO depending upon liability)"',
    },
    {
        code: '187',
        category: 'Patient Responsibility',
        description: '"Consumer Spending Account payments (includes but is not limited to Flexible Spending Account, Health Savings Account, Health Reimbursement Account, etc.)"',
    },
    {
        code: '204',
        category: 'Patient Responsibility',
        description: 'This service/equipment/drug is not covered under This service/equipment/drug is not covered under the patient?s current benefit plan',
    },
    {
        code: '29',
        category: 'Patient Responsibility',
        description: 'The time limit for filing has expired. The time limit for filing has expired.',
    },
    {
        code: '49',
        category: 'Patient Responsibility',
        description:
            '"This is a non-covered service because it is a routine/preventive exam or a diagnostic/screening procedure done in conjunction with a routine/preventive exam. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '102',
        category: 'Patient Responsibility',
        description: 'Major Medical Adjustment. Major Medical Adjustment.',
    },
    {
        code: '22',
        category: 'Patient Responsibility',
        description: 'This care may be covered by another payer per coo This care may be covered by another payer per coordination of benefits.',
    },
    {
        code: '33',
        category: 'Patient Responsibility',
        description: 'Insured has no dependent coverage. Insured has no dependent coverage.',
    },
    {
        code: '200',
        category: 'Patient Responsibility',
        description: 'Expenses incurred during lapse in coverage Expenses incurred during lapse in coverage',
    },
    {
        code: 'NSF',
        category: 'Patient Responsibility',
        description: 'NON-SUFFICIENT FUNDS NON-SUFFICIENT FUNDS',
    },
    {
        code: '167',
        category: 'Patient Responsibility',
        description:
            '"This (these) diagnosis(es) is (are) not covered. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '177',
        category: 'Patient Responsibility',
        description: 'Patient has not met the required eligibility requ Patient has not met the required eligibility requirements.',
    },
    {
        code: '19',
        category: 'Patient Responsibility',
        description: "This is a work-related injury/illness and thus th This is a work-related injury/illness and thus the liability of the Worker's Compensation Carrier.",
    },
    {
        code: '226',
        category: 'Patient Responsibility',
        description:
            '"Information requested from the Billing/Rendering Provider was not provided or not provided timely or was insufficient/incomplete. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)"',
    },
    {
        code: '16',
        category: 'Patient Responsibility',
        description:
            '"Claim/service lacks information or has submission/billing error(s) which is needed for adjudication. Do not use this code for claims attachment(s)/other documentation. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.) Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '51',
        category: 'Patient Responsibility',
        description:
            '"These are non-covered services because this is a pre-existing condition. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '119',
        category: 'Patient Responsibility',
        description: 'Benefit maximum for this time period or occurrenc Benefit maximum for this time period or occurrence has been reached.',
    },
    {
        code: 'A0',
        category: 'Patient Responsibility',
        description: 'Patient refund amount. Patient refund amount.',
    },
    {
        code: '26',
        category: 'Patient Responsibility',
        description: 'Expenses incurred prior to coverage. Expenses incurred prior to coverage.',
    },
    {
        code: 'B9',
        category: 'Patient Responsibility',
        description: 'Patient is enrolled in a Hospice. Patient is enrolled in a Hospice.',
    },
    {
        code: '148',
        category: 'Patient Responsibility',
        description:
            '"Information from another provider was not provided or was insufficient/incomplete. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)"',
    },
    {
        code: '40',
        category: 'Patient Responsibility',
        description:
            '"Charges do not meet qualifications for emergent/urgent care. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '252',
        category: 'Patient Responsibility',
        description:
            '"An attachment/other documentation is required to adjudicate this claim/service. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT)."',
    },
    {
        code: '109',
        category: 'Patient Responsibility',
        description:
            'Claim/service not covered by this payer/contracto Claim/service not covered by this payer/contractor. You must send the claim/service to the correct payer/contractor.',
    },
    {
        code: '243',
        category: 'Patient Responsibility',
        description: 'Services not authorized by network/primary care p Services not authorized by network/primary care providers.',
    },
    {
        code: '100',
        category: 'Patient Responsibility',
        description: 'Payment made to patient/insured/responsible party Payment made to patient/insured/responsible party/employer.',
    },
    {
        code: 'A1',
        category: 'Patient Responsibility',
        description:
            '"Claim/Service denied. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)"',
    },
    {
        code: '32',
        category: 'Patient Responsibility',
        description: 'Our records indicate that this dependent is not a Our records indicate that this dependent is not an eligible dependent as defined.',
    },
    {
        code: '179',
        category: 'Patient Responsibility',
        description:
            '"Patient has not met the required waiting requirements. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: 'B20',
        category: 'Patient Responsibility',
        description: 'Procedure/service was partially or fully furnishe Procedure/service was partially or fully furnished by another provider.',
    },
    {
        code: '256',
        category: 'Patient Responsibility',
        description: 'Service not payable per managed care contract. Service not payable per managed care contract.',
    },
    {
        code: '275',
        category: 'Patient Responsibility',
        description: '"Prior payer\'s (or payers\') patient responsibility (deductible, coinsurance, co-payment) not covered. (Use only with Group Code PR)"',
    },
    {
        code: '288',
        category: 'Patient Responsibility',
        description: 'Referral absent Referral absent',
    },
    {
        code: '276',
        category: 'Patient Responsibility',
        description: 'Services denied by the prior payer(s) are not cov Services denied by the prior payer(s) are not covered by this payer.',
    },
    {
        code: 'B7',
        category: 'Patient Responsibility',
        description:
            '"This provider was not certified/eligible to be paid for this procedure/service on this date of service. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '4',
        category: 'Patient Responsibility',
        description:
            '"The procedure code is inconsistent with the modifier used or a required modifier is missing. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '197',
        category: 'Patient Responsibility',
        description: 'Precertification/authorization/notification absen Precertification/authorization/notification absent.',
    },
    {
        code: 'PR-PT RESP',
        category: 'Patient Responsibility',
        description: 'MPB not Active "Medicare Part B not Active as primary, Patient Resp as per Secondary"',
    },
    {
        code: '210',
        category: 'Patient Responsibility',
        description: 'Payment adjusted because pre-certification/author Payment adjusted because pre-certification/authorization not received in a timely fashion',
    },
    {
        code: 'B13',
        category: 'Patient Responsibility',
        description: 'Previously paid. Payment for this claim/service m Previously paid. Payment for this claim/service may have been provided in a previous payment.',
    },
    {
        code: 'CBF',
        category: 'Patient Responsibility',
        description: 'CBF CHECK BOUNCED FEE',
    },
    {
        code: '23',
        category: 'Patient Responsibility',
        description: '"The impact of prior payer(s) adjudication including payments and/or adjustments. (Use only with Group Code OA)"',
    },
    {
        code: 'B15',
        category: 'Patient Responsibility',
        description:
            '"This service/procedure requires that a qualifying service/procedure be received and covered. The qualifying other service/procedure has not been received/adjudicated. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '97',
        category: 'Patient Responsibility',
        description:
            '"The benefit for this service is included in the payment/allowance for another service/procedure that has already been adjudicated. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: 'B16',
        category: 'Patient Responsibility',
        description: "'New Patient' qualifications were not met. 'New Patient' qualifications were not met.",
    },
    {
        code: '185',
        category: 'Patient Responsibility',
        description:
            '"The rendering provider is not eligible to perform the service billed. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '94',
        category: 'Payer Initiated Reductions',
        description: 'Processed in Excess of charges. Processed in Excess of charges.',
    },
    {
        code: '231',
        category: 'Payer Initiated Reductions',
        description:
            '"Mutually exclusive procedures cannot be done in the same day/setting. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: 'B13',
        category: 'Payer Initiated Reductions',
        description: 'Previously paid. Payment for this claim/service m Previously paid. Payment for this claim/service may have been provided in a previous payment.',
    },
    {
        code: '97',
        category: 'Payer Initiated Reductions',
        description:
            '"The benefit for this service is included in the payment/allowance for another service/procedure that has already been adjudicated. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '59',
        category: 'Payer Initiated Reductions',
        description:
            '"Processed based on multiple or concurrent procedure rules. (For example multiple surgery or diagnostic imaging, concurrent anesthesia.) Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '252',
        category: 'Payer Initiated Reductions',
        description:
            '"An attachment/other documentation is required to adjudicate this claim/service. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT)."',
    },
    {
        code: '119',
        category: 'Payer Initiated Reductions',
        description: 'Benefit maximum for this time period or occurrenc Benefit maximum for this time period or occurrence has been reached.',
    },
    {
        code: '4',
        category: 'Payer Initiated Reductions',
        description:
            '"The procedure code is inconsistent with the modifier used or a required modifier is missing. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '16',
        category: 'Payer Initiated Reductions',
        description:
            '"Claim/service lacks information or has submission/billing error(s) which is needed for adjudication. Do not use this code for claims attachment(s)/other documentation. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.) Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '109',
        category: 'Payer Initiated Reductions',
        description:
            'Claim/service not covered by this payer/contracto Claim/service not covered by this payer/contractor. You must send the claim/service to the correct payer/contractor.',
    },
    {
        code: 'A1',
        category: 'Payer Initiated Reductions',
        description:
            '"Claim/Service denied. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)"',
    },
    {
        code: '242',
        category: 'Payer Initiated Reductions',
        description: 'Services not provided by network/primary care pro Services not provided by network/primary care providers.',
    },
    {
        code: '236',
        category: 'Payer Initiated Reductions',
        description:
            'This procedure or procedure/modifier combination This procedure or procedure/modifier combination is not compatible with another procedure or procedure/modifier combination provided on the same day according to the National Correct Coding Initiative or workers compensation state regulations/ fee schedule requirements.',
    },
    {
        code: '96',
        category: 'Payer Initiated Reductions',
        description:
            '"Non-covered charge(s). At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.) Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '140',
        category: 'Payer Initiated Reductions',
        description: 'Patient/Insured health identification number and Patient/Insured health identification number and name do not match.',
    },
    {
        code: '18',
        category: 'Payer Initiated Reductions',
        description:
            "Exact duplicate claim/service (Use only with Grou Exact duplicate claim/service (Use only with Group Code OA except where state workers' compensation regulations requires CO)",
    },
    {
        code: '11',
        category: 'Payer Initiated Reductions',
        description:
            '"The diagnosis is inconsistent with the procedure. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '29',
        category: 'Payer Initiated Reductions',
        description: 'The time limit for filing has expired. The time limit for filing has expired.',
    },
    {
        code: '222',
        category: 'Payer Initiated Reductions',
        description:
            '"Exceeds the contracted maximum number of hours/days/units by this provider for this period. This is not patient specific. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '100',
        category: 'Payer Initiated Reductions',
        description: 'Payment made to patient/insured/responsible party Payment made to patient/insured/responsible party/employer.',
    },
    {
        code: '22',
        category: 'Payer Initiated Reductions',
        description: 'This care may be covered by another payer per coo This care may be covered by another payer per coordination of benefits.',
    },
    {
        code: '226',
        category: 'Payer Initiated Reductions',
        description:
            '"Information requested from the Billing/Rendering Provider was not provided or not provided timely or was insufficient/incomplete. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)"',
    },
    {
        code: 'B22',
        category: 'Payer Initiated Reductions',
        description: 'This payment is adjusted based on the diagnosis. This payment is adjusted based on the diagnosis.',
    },
    {
        code: '15',
        category: 'Payer Initiated Reductions',
        description: '"The authorization number is missing, invalid, or does not apply to the billed services or provider."',
    },
    {
        code: '197',
        category: 'Payer Initiated Reductions',
        description: 'Precertification/authorization/notification absen Precertification/authorization/notification absent.',
    },
    {
        code: '239',
        category: 'Payer Initiated Reductions',
        description: 'Claim spans eligible and ineligible periods of co Claim spans eligible and ineligible periods of coverage. Rebill separate claims.',
    },
    {
        code: '129',
        category: 'Payer Initiated Reductions',
        description:
            '"Prior processing information appears incorrect. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)"',
    },
    {
        code: '9',
        category: 'Payer Initiated Reductions',
        description:
            '"The diagnosis is inconsistent with the patient\'s age. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '234',
        category: 'Payer Initiated Reductions',
        description:
            '"This procedure is not paid separately. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)"',
    },
    {
        code: 'B15',
        category: 'Payer Initiated Reductions',
        description:
            '"This service/procedure requires that a qualifying service/procedure be received and covered. The qualifying other service/procedure has not been received/adjudicated. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '146',
        category: 'Payer Initiated Reductions',
        description: 'Diagnosis was invalid for the date(s) of service Diagnosis was invalid for the date(s) of service reported.',
    },
    {
        code: '45',
        category: 'Payer Initiated Reductions',
        description:
            'Charge exceeds fee schedule/maximum allowable or Charge exceeds fee schedule/maximum allowable or contracted/legislated fee arrangement. Note: This adjustment amount cannot equal the total service or claim charge amount; and must not duplicate provider adjustment amounts (payments and contractual reductions) that have resulted from prior payer(s) adjudication. (Use only with Group Codes PR or CO depending upon liability)',
    },
    {
        code: '223',
        category: 'Payer Initiated Reductions',
        description:
            '"Adjustment code for mandated federal, state or local law/regulation that is not already covered by another code and is mandated before a new code can be created."',
    },
    {
        code: '181',
        category: 'Payer Initiated Reductions',
        description: 'Procedure code was invalid on the date of service Procedure code was invalid on the date of service.',
    },
    {
        code: '23',
        category: 'Payer Initiated Reductions',
        description: '"The impact of prior payer(s) adjudication including payments and/or adjustments. (Use only with Group Code OA)"',
    },
    {
        code: 'B11',
        category: 'Payer Initiated Reductions',
        description: '"The claim/service has been transferred to the proper payer/processor for processing. Claim/service not covered by this payer/processor."',
    },
    {
        code: '251',
        category: 'Payer Initiated Reductions',
        description:
            '"The attachment/other documentation that was received was incomplete or deficient. The necessary information is still needed to process the claim. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT)."',
    },
    {
        code: '131',
        category: 'Payer Initiated Reductions',
        description: 'Claim specific negotiated discount. Claim specific negotiated discount.',
    },
    {
        code: '216',
        category: 'Payer Initiated Reductions',
        description: 'Based on the findings of a review organization Based on the findings of a review organization',
    },
    {
        code: '151',
        category: 'Payer Initiated Reductions',
        description:
            'Payment adjusted because the payer deems the info Payment adjusted because the payer deems the information submitted does not support this many/frequency of services.',
    },
    {
        code: '148',
        category: 'Payer Initiated Reductions',
        description:
            '"Information from another provider was not provided or was insufficient/incomplete. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)"',
    },
    {
        code: '253',
        category: 'Payer Initiated Reductions',
        description: 'Sequestration - reduction in federal payment Sequestration - reduction in federal payment',
    },
    {
        code: '250',
        category: 'Payer Initiated Reductions',
        description:
            '"The attachment/other documentation that was received was the incorrect attachment/document. The expected attachment/document is still missing. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT)."',
    },
    {
        code: '10',
        category: 'Payer Initiated Reductions',
        description:
            '"The diagnosis is inconsistent with the patient\'s gender. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '5',
        category: 'Payer Initiated Reductions',
        description:
            '"The procedure code/bill type is inconsistent with the place of service. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
    {
        code: '107',
        category: 'Payer Initiated Reductions',
        description:
            '"The related or qualifying claim/service was not identified on this claim. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."',
    },
]
